{
  "404.message": "Siden, du forsøgte at besøge, kunne ikke findes. Dette kunne skyldes:",
  "404.message.reason1": "Denne side eksisterer ikke.",
  "404.message.reason2": "Siden findes, men du har ikke tilladelse til at se den.",
  "404.nav.dashboard": "Dit betjeningspanel",
  "404.nav.home": "Webstedets hjemside",
  "404.nav.title": "Gå til",
  "404.search.title": "Søgning på side",
  "aboutpage.section.title": "Atlassian Confluence Cloud og udvidelser til Confluence Cloud",
  "accessibility.user.icon": "Brugerikon",
  "action.add.comment": "Tilføj kommentar",
  "action.edit.comment": "Rediger kommentar",
  "action.reorder.pages.sentence": "Omarrangér sider",
  "action.space.addons": "Tilføjelser",
  "action.space.overview": "Oversigt",
  "actions.word": "Handlinger",
  "add.comment": "Tilføj kommentar",
  "add.comment.accesskey": "m",
  "add.shortcut": "Tilføj genvej",
  "add.word": "Tilføj",
  "addlabels.teamlabels": "Kategorier",
  "adf.translation.error.in.render.description.prod": "Genindlæs siden, og prøv igen. Hvis problemet fortsætter skal du kontakte <a target=\"_blank\" href=\"{link}\">Atlassian-support</a>.",
  "adf.translation.error.in.render.description.staging": "En ADF-fejl forhindrer dit indhold i at blive vist. Diskutér yderligere i <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a>-kanalen i Slack.",
  "adf.translation.error.in.render.title.prod": "Vi kunne ikke vise dit indhold",
  "adf.translation.error.in.render.title.staging": "ADF-fejl ved visning af indholdet",
  "adg3.feedback.placeholder": "Fortæl os om din oplevelse med Confluence så vi kan gøre den endnu bedre.",
  "adg3.give.feedback": "Giv feedback",
  "adg3.onboarding.docs.link": "Lær mere",
  "adg3.onboarding.next": "Næste",
  "adg3.onboarding.prev": "Tidligere",
  "adg3.onboarding.sidebar.done": "Det er forstået",
  "adg3.onboarding.skip": "Spring over",
  "adg3.onboarding.start": "Kom i gang",
  "adg3.onboarding.step1.content": "Vi har opdateret farver, ikoner og skrifttyper, så de vigtige ting er nemmere at få øje på, og dine øjne slipper for at arbejde så hårdt.",
  "adg3.onboarding.step1.title": "Hils på din nye Confluence-oplevelse",
  "adg3.onboarding.step2.content": "Det du mest får brug for - søg, opret og naviger - er alt sammen at finde i sidepanelet.",
  "adg3.onboarding.step2.title": "Enkel navigation i sidepanel",
  "adg3.onboarding.step3.content": "Kan du ikke huske, hvad du arbejdede på? Søgepanelet giver dig en hjælpende hånd med en liste over dine nyligt besøgte sider.",
  "adg3.onboarding.step3.title": "Fortsæt fra hvor du slap sidst",
  "adg3.onboarding.step4.content": "Giv feedback via din profil for at gøre dette endnu bedre. Ikke klar til den nye oplevelse endnu? Du kan også slå det fra via din profil.",
  "adg3.onboarding.step4.content.no.optout": "Din feedback spiller en stor rolle i forbedringen afConfluence oplevelsen. Fortæl os hvad du synes via din profil, for at hjælpe os med at gøre den endnu bedre.",
  "adg3.onboarding.step4.title": "Hjælp os med at skabe det bedste Confluence",
  "adg3.onboarding.user.optin.content": "Vi har foretaget ændringer på baggrund af feedback, men vi forbedrer os stadig. Smid os en note via Giv feedback i sidelinjen, hvis du har mere at dele.",
  "adg3.onboarding.user.optin.done": "Det er forstået",
  "adg3.onboarding.user.optin.title": "Den nye Confluence oplevelse er her nu for alle",
  "adg3.send.feedback": "Send feedback",
  "adg3.sidebar.button.configure": "Konfigurer sidelinje",
  "adg3.sidebar.button.done": "Færdig",
  "adg3.sidebar.button.gotit": "Det er forstået",
  "adg3.sidebar.link.disable": "Deaktivér",
  "adg3.sidebar.link.enable": "Aktivér",
  "adg3.user.profile.other": "Min Confluence",
  "admin.section.security.title": "Brugere & sikkerhed",
  "administration.name": "Administration",
  "all.updates.mainBanner": "Der sker ikke så meget... Endnu",
  "all.updates.subBanner": "Hold dig opdateret på alt der sker på dette websted. Alle nye sider, filer, redigeringer og kommentarer vil blive vist her.",
  "all.updates.subBanner2": "Så er det tid til at skabe det næste helt store.",
  "all.updates.title": "Alle opdateringer",
  "anonymous.name": "Anonym",
  "archived.spaces": "Arkiverede rum",
  "atlassian.can.contact": "Må vi kontakte dig for opfølgning på din feedback?",
  "atlassian.home.name": "Atlassian Home",
  "attach.files.no.permission": "Du skal spørge om tilladelse for at kunne indsætte filer her.",
  "attach.files.tip.close": "Ok, det er forstået!",
  "attach.files.tip.desc": "Slip filer på din side for at indsætte dem direkte.",
  "attach.files.tip.title": "Tip:",
  "attach.files.upload.files": "Upload filer",
  "attach.files.upload.images": "Upload billeder",
  "audit.logging.category.user.management": "Brugere og grupper",
  "aui.sidebar.collapse.tooltip": "Skjul sidepanel ( [ )",
  "aui.sidebar.expand.tooltip": "Udvid sidepanel ( [ )",
  "author.name": "Forfatter",
  "blog.personal.name": "Personlig blog",
  "blog.post": "Blogindlæg",
  "blog.word": "Blog",
  "blogtree.failed.load.content": "Kunne indlæse blogindlæg",
  "blueprint.navigation.items.create.new.template": "Opret ny skabelon",
  "blueprint.navigation.items.create.new.template.disabled": "Kun områdeadministratorer kan oprette skabeloner",
  "blueprint.navigation.items.filter.for.templates": "Filtrér skabeloner",
  "blueprint.navigation.items.page.templates.header": "Sideskabeloner",
  "button.cancel": "Annuller",
  "cache.name.com.atlassian.confluence.pages.Draft": "Kladder",
  "calendar.share.button.keyboard.shortcut.desc": "Del",
  "calendar3.addcalendar": "Tilføj kalender",
  "calendar3.helptip.learn.more": "Lær mere",
  "calendar3.spacecalendars.header": "Kalendere",
  "calendar3.spacecalendars.onboarding.button.add.label": "Tilføj kalender",
  "calendar3.spacecalendars.onboarding.intro": "Tilføj en kalender for at holde styr på dit holds orlov, planlæg Jira-projekter og få alle til at kunne komme på vigtige dage.",
  "calendar3.spacecalendars.onboarding.title": "Kilden til sandhed for dit hold eller projekt",
  "cancel.name": "Annuller",
  "captcha.response.failed": "Den indtastede ord passede ikke teksten i billedet.",
  "categories.name": "Kategorier",
  "changeboarding.dnd.pagetree.spacesettings.banner": "Det er lige blevet lettere at organisere rum med muligheden for at trække og slippe. når du arrangerer sider i din sidebjælke",
  "changeboarding.dnd.pagetree.spotlight.message": "Træk og slip for at flytte sider og organisere dit rum.",
  "changes-diff.heading.key": "Tegnforklaring",
  "changes-diff.these.lines.were.added": "Denne linje blev tilføjet.",
  "changes-diff.these.lines.were.removed": "Denne linje blev fjernet.",
  "changes-diff.this.content.was.modified": "Formatering blev ændret.",
  "clear.name": "Ryd",
  "clipboardaccess.browser.not.supported": "Din browser understøtter ikke indsættelse af billeder fra udklipsholderen.",
  "clipboardaccess.ok": "OK",
  "close.draft.name": "Luk udkast",
  "close.name": "Luk",
  "collab.edit.user.limit.msg.body": "<p>Denne side er så populær, at du har nået det maksimale antal samtidige redaktører.</p><p>Prøv igen når der ikke er så travlt.",
  "collab.edit.user.limit.msg.title": "Du kan ikke redigere denne side lige nu",
  "collab.status.connected": "Klar til at gå i gang",
  "collab.status.connecting": "Forbinder...",
  "collab.status.error": "Kan ikke gemme ændringer",
  "collab.status.tooltip.error": "Kopier dit arbejde, genopfrisk siden, og vi vil prøve at genoprette forbindelsen.",
  "collab.status.tooltip.failure": "Kan ikke nå serveren. Kontrollér din internetforbindelse, og vi vil fortsat prøve at genoprette din forbindelse.",
  "collab.status.tooltip.success": "Vi gemmer automatisk dine ændringer",
  "collapse.name": "Luk",
  "colourname.property.style.bordercolour": "Kanter og delelinjer",
  "colourname.property.style.breadcrumbstextcolour": "Tekst til øverste panel",
  "colourname.property.style.headerbuttonbasebgcolour": "Baggrund til overskriftsknap",
  "colourname.property.style.headerbuttontextcolour": "Tekst til overskriftsknap",
  "colourname.property.style.headingtextcolour": "Overskriftstekst",
  "colourname.property.style.linkcolour": "Links",
  "colourname.property.style.menuitemselectedbgcolour": "Valgt baggrund til menuelement",
  "colourname.property.style.menuitemselectedtextcolour": "Valgt tekst til menuelement",
  "colourname.property.style.menuitemtextcolour": "Elementtekst til sidemenu",
  "colourname.property.style.menuselectedbgcolour": "Valgt baggrund til sidemenu",
  "colourname.property.style.navbgcolour": "Baggrund til fanenavigation",
  "colourname.property.style.navselectedbgcolour": "Baggrundsfremhævning af fanenavigation",
  "colourname.property.style.navselectedtextcolour": "Tekstfremhævning af fanenavigation",
  "colourname.property.style.navtextcolour": "Tekst til fanenavigation",
  "colourname.property.style.searchfieldbgcolour": "Baggrund på søgefelt",
  "colourname.property.style.searchfieldtextcolour": "Søg i felttekst",
  "colourname.property.style.spacenamecolour": "Tekst til områdets navn",
  "colourname.property.style.topbarcolour": "Toppanel",
  "colourname.property.style.topbarmenuitemtextcolour": "Elementtekst til toppanelmenu",
  "colourname.property.style.topbarmenuselectedbgcolour": "Valgte baggrund til toppanelmenuen",
  "colourname.property.style.topbarmenuselectedtextcolour": "Valgt elementtekst til toppanelmenu",
  "com.atlassian.confluence.contributors.contributors.label": "Bidragydere",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "Vis fil",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "Det er forstået, tak!",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "Rediger side",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "Roadmap-planlægger",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "Sidetræ",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "Filter",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "Tip: skriv \"g\" og derefter \"r\" hvor som helst for hurtigt at åbne denne menu",
  "com.atlassian.confluence.plugins.recently.viewed.title": "Nyligt besøgte sider",
  "com.atlassian.confluence.plugins.status-macro.status.label": "Status",
  "com.atlassian.mywork.header.notifications": "Meddelelser",
  "comment.display.name.anonymous": "Anonym",
  "comment.edit": "Rediger",
  "comment.edited": "Redigeret",
  "comment.name.tooltip": "Tilføj en kommentar",
  "comment.notification.enable": "Følg denne side",
  "comment.permalink": "Permalink",
  "comment.plural": "{0} kommentarer",
  "comment.remove": "Slet",
  "comment.reply": "Svar",
  "comment.singular": "1 kommentar",
  "compare.selected": "Sammenlign valgte versioner",
  "configuration.name": "Konfiguration",
  "confluence.extra.attachments.attachments.label": "Vedhæftninger",
  "confluence.extra.jira.jira.label": "Jira",
  "confluence.extra.masterdetail.detailssummary.label": "Page Properties Report",
  "confluence.home": "Confluence-hjem",
  "confluence.macros.advanced.children.label": "Visning af underordnet side",
  "confluence.macros.advanced.contentbylabel.label": "Indhold efter label",
  "confluence.macros.advanced.recently-updated.label": "Nyligt opdateret",
  "confluence.mobile.nav.switch.to.mobile.action": "Skift til Confluence mobile",
  "confluence.mobile.nav.switch.to.mobile.text": "Du ser computerversionen på en mobil enhed.",
  "confluence.mobile.refresh": "Opdatér",
  "confluence.request.access.pagerestricted.inherited.description": "Dette skyldes at den har restriktioner fra en overordnet side. En rum-admin eller personen, som delte denne side kan måske give dig adgang.",
  "confluence.request.access.pagerestricted.request.access.button": "Anmod om adgang",
  "confluence.request.access.pagerestricted.requestaccess.description": "Tryk på 'anmod om adgang'-knappen, så finder vi nogen som kan give dig adgang",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "Du har ikke tilladelse til at redigere denne side",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "Du har ikke tilladelse til at se denne side",
  "confluence.user.profile.department": "Afdeling",
  "confluence.user.profile.location": "Placering",
  "confluence.user.profile.position": "Placering",
  "connect.addon.wait.or": "Vent eller",
  "content.empty": "Kommentaren er tom. Kan ikke oprette tomme kommentarer.",
  "content.kind.decisions": "Beslutning",
  "content.kind.file-list": "Filliste",
  "content.kind.jirareport": "Jira-rapport",
  "content.kind.kb-how-to-article": "Hvordan skrives en artikel",
  "content.kind.kb-troubleshooting-article": "Fejlfinding af artikel",
  "content.kind.meeting-notes": "Mødenotater",
  "content.kind.product-requirements": "Produktkrav",
  "content.kind.retrospective": "Retrospektivt",
  "content.kind.shared-links": "Delte links",
  "content.kind.task-report": "Opgaverapport",
  "content.type.attachment": "Vedhæftede filer",
  "content.type.blogpost": "Nyheder",
  "content.type.page": "Sider",
  "cq.header.title": "Spørgsmål",
  "create.blog.post.event.description": "Opret nyhedsindlæg",
  "create.drawer.header": "Opret",
  "create.drawer.page.selector.all.pages.in.space": "Alle sider i dette område",
  "create.drawer.page.selector.location.header": "Placering",
  "create.drawer.page.selector.no.page.found": "Ingen sider fundet",
  "create.drawer.page.selector.no.parent.page": "Ingen overside",
  "create.drawer.page.selector.pages.loading": "Indlæser sider",
  "create.drawer.page.selector.parent.page": "Overordnet side",
  "create.drawer.page.selector.parent.page.tooltip.help": "Blogs, kalendere og spørgsmål vises ikke under en overordnet side",
  "create.drawer.page.selector.recent.pages": "Seneste sider",
  "create.drawer.page.selector.select.parent.page": "Vælg en overordnet side",
  "create.drawer.space.selector.header": "Område",
  "create.drawer.space.selector.location.header": "Placering",
  "create.drawer.space.selector.no.space.found": "Ingen områder fundet",
  "create.drawer.space.selector.recent.spaces": "Seneste områder",
  "create.drawer.space.selector.search.spaces": "Alle områder",
  "create.drawer.space.selector.select.a.space": "Vælg et område",
  "create.drawer.space.selector.spaces.loading": "Indlæser områder",
  "create.drawer.space.selector.starred.spaces": "Stjernemarkerede områder",
  "create.drawer.template.failed.to.load.atlassian.support": "Atlassian Support.",
  "create.drawer.template.failed.to.load.content": "Opdatér siden, og prøv igen. Hvis problemet fortsætter, skal du kontakte",
  "create.drawer.template.failed.to.load.title": "Skabelonen kunne ikke indlæses",
  "create.name": "Opret",
  "css.file": "CSS-fil",
  "current.space": "Nuværende rum",
  "default.space.homepage.title": "{0} Hjem",
  "delete.name": "Slet",
  "desc.colourscheme": "Følgende farver kan tilpasses til dette farveskema.",
  "description.name": "Beskrivelse",
  "discard.name": "Kassér",
  "discover.applications": "Oplev applikationer",
  "draft": "Udkast",
  "draft.no.content": "Dette udkast har intet indhold.",
  "edit.comment": "Rediger kommentar",
  "edit.labels": "Tilføj labels",
  "editor-help.fabric.help.center.feedback.item": "Feedback",
  "editor.adf.parsing.error.details": "Detaljer om fejlen:",
  "editor.adf.parsing.error.message.prod": "Genindlæs siden, og prøv igen. Hvis problemet fortsætter skal du kontakte <a target=\"_blank\" href=\"{link}\">Atlassian-support</a>.",
  "editor.adf.parsing.error.message.staging": "Vores team har fået besked, men du kan også diskutere det på <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a>-kanalen i Slack.",
  "editor.adf.parsing.error.title.prod": "Vi kunne ikke indlæse editoren.",
  "editor.adf.parsing.error.title.staging": "Vi havde et problem med at konvertere dette dokument til ADF",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} Vedhæftede filer",
  "editor.attachments.singular": "{0} Vedhæftning",
  "editor.attachments.zero": "Vedhæftede filer",
  "editor.autocomplete.file.header.text": "Filanbefalinger",
  "editor.autocomplete.links.create.link": "Indsæt link for at oprette en side",
  "editor.autocomplete.links.dialog.search": "Søg efter ‘{0}’",
  "editor.autocomplete.links.dialog.search.no.text": "Søg",
  "editor.autocomplete.links.header.text": "Anbefalinger af link",
  "editor.autocomplete.links.web.link": "Indsæt weblink",
  "editor.autocomplete.macros.dialog.browse": "Åben makrobrowseren",
  "editor.autocomplete.macros.error.load.header": "Kunne ikke indhente makrooplysninger",
  "editor.autocomplete.macros.error.load.retrylink": "Prøv igen",
  "editor.autocomplete.macros.header.text": "Makroanbefalinger",
  "editor.autocomplete.media.files.dialog.browse": "Åben filbiblioteket",
  "editor.autocomplete.media.header.text": "Medieforslag",
  "editor.autocomplete.media.images.dialog.browse": "Åbn billedbrowser",
  "editor.autocomplete.media.macros.dialog.browse": "Indsæt andet medie",
  "editor.autoformat.sampletext.firstcell": "første celle",
  "editor.autoformat.sampletext.heading": "overskrift",
  "editor.buttons.disable.by.empty.title.tooltip": "Din side skal have en titel, før den kan blive offentliggjort.",
  "editor.buttons.disable.by.not.saving.tooltip": "Arbejder stadig...",
  "editor.buttons.disable.by.saving.tooltip": "Vi er ikke færdige med at gemme din side.",
  "editor.cancel.discard.changes.confirmation": "Kassér ændringer",
  "editor.cancel.discard.changes.message": "Al indtastet indhold vil blive kasseret. Bekræft venligst.",
  "editor.cancel.discard.changes.title": "Bekræft kassering af alle ændringer",
  "editor.cant.publish.changes": "Kan ikke offentliggøre ændringer",
  "editor.change.comment": "Hvad har du ændret?",
  "editor.close.publish.tooltip": "Gem ændringer uden at udgive",
  "editor.close.update.tooltip": "Gem ændringer uden at opdatere",
  "editor.collab.user.limit.body": "Denne side er så populær, at du har nået det maksimale samtidige redaktører. Prøv igen når den ikke er så travl.",
  "editor.collab.user.limit.title": "Du kan ikke redigere denne side lige nu.",
  "editor.collaborative-editing.load.error": "Indlæsning af editoren tager længere tid end sædvanligt. Giv det et øjeblik og genindlæs derefter din side, hvis den stadig ikke indlæses. Tal med din Confluence-administrator, hvis det ikke løser det.",
  "editor.collaborative-editing.refresh-editor.error": "Noget gik galt under indlæsning af editoren. Prøv venligst igen.",
  "editor.collaborative.mode.disabled": "Samarbejdsredigering er offline lige nu. Kopier dit arbejde og opdater derefter siden for at fortsætte med at redigere.",
  "editor.collaborative.mode.enabled": "Samarbejdsredigering var blevet slukket, men det kører igen. Kopier dine ændringer og genindlæs siden for at fortsætte med at redigere.",
  "editor.content.appearance.toggle.fixed.width": "Lav siden fuld bredde",
  "editor.content.appearance.toggle.full.width": "Fastlås sidens bredde",
  "editor.content.placeholder.11": "Vidste du, at du kan tilføje alle mulige seje ting på denne side, såsom en indholdsfortegnelse, dato eller køreplan? Indtast / for at åbne en liste.",
  "editor.content.placeholder.ai": "Skriv /ai for Atlassian Intelligence, / for at tilføje elementer eller @ for at omtale nogen (så giver vi dem besked).",
  "editor.content.placeholder.bpqa": "Tast / for at se en liste over elementer, @ for at omtale nogen, eller vælg fra nedenstående:",
  "editor.content.placeholder.bpqa.ai": "Skriv /ai for Atlassian Intelligence, / for elementer, @ for at omtale nogen, eller vælg fra nedenstående:",
  "editor.content.placeholder.easy.mentions": "Tast / for alle elementer eller @ for at omtale nogen.",
  "editor.content.placeholder.slash": "Skriv /for at indsætte et hvilket som helst element",
  "editor.content.placeholder.slash.bracket": "Et element kan hurtigt indsættes ved at skrive /",
  "editor.content.reconciliation.error.details": "Fejloplysninger:",
  "editor.content.reconciliation.error.fatal.prod": "Vores team har fået besked. Vent nogle minutter, og prøv så igen. Hvis problemet fortsætter, skal du kontakte Atlassian-support.",
  "editor.content.reconciliation.error.fatal.staging": "Vores team har fået besked, men du kan også diskutere det på #cc-content-experience-kanalen i Slack.",
  "editor.content.reconciliation.error.retrying": "Prøver igen om {0} ...",
  "editor.content.reconciliation.error.title": "Denne side er ikke blevet indlæst",
  "editor.content.reconciliation.networkerror.fatal.prod": "Opdatering af siden bør løse problemet. Hvis problemet fortsætter, kan du kontakte <a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">Atlassian-support</a> eller din områdeadministrator.",
  "editor.content.reconciliation.networkerror.title": "Vi har problemer med at indlæse dit indhold",
  "editor.discard-on-close.tooltip": "Kassér tomt udkast",
  "editor.discard-to-published.button.label": "Kassér",
  "editor.discard-to-published.button.tooltip": "Vend tilbage til sidste udgivede version af siden",
  "editor.discard-to-published.dialog.title": "Kassér ikke-udgivede ændringer?",
  "editor.discard-to-published.dialog.warning": "Dette vil gendanne editoren til den sidste udgivede version af denne side. Hvis andre har ikke-udgivede ændringer på siden, vil du også kassere disse ændringer.",
  "editor.discard-to-published.error.message": "Vi kan i øjeblikket ikke indhente den seneste udgivede version af siden. Giv det et øjeblik og prøv derefter at kassere udkastet igen.",
  "editor.discard-to-published.error.title": "Kan ikke gendanne til den seneste udgivede version",
  "editor.discard-to-published.success.message": "Vendt tilbage til den sidste udgivede version med succes",
  "editor.draft.can.be.migrated": "Samarbejdsredigering er kommet! For at du kan fortsætte med at arbejde på denne side, er vi nødt til at overføre indholdet til et nyt udkast til dig.<br> <a href={0}>Overfør nu</a>",
  "editor.dynamic-macro.preview.limit.desc": "Forhåndsvisning af dynamisk makro på udkast understøttes kun helt, når delte udkast er aktiveret.",
  "editor.ellipsis.blog.delete": "Slet ikke-udgivet blogindlæg",
  "editor.ellipsis.import-document": "Åbn Skabeloner og dokumentimport",
  "editor.ellipsis.open.template.browser": "Åbn skabelonbrowser",
  "editor.ellipsis.open.templates.and.import": "Skabeloner og dokumentimport",
  "editor.ellipsis.page.delete": "Slet ikke-udgivet side",
  "editor.ellipsis.remove": "Vend tilbage til sidste udgivede version",
  "editor.ellipsis.resolved.comments": "Løste kommentarer",
  "editor.ellipsis.view-changes": "Se ændringer",
  "editor.error.delayed.publishing": "Vi prøver stadig at udgive siden. Hvis det tager for lang tid, kan du opdatere siden og klikke på <strong>Udgiv</strong>.",
  "editor.error.delayed.publishing.title": "Vi har problemer med at udgive dit indhold.",
  "editor.excerpt.include.macro.error": "Fejl ved indlæsning af uddrag fra \"{0}\".",
  "editor.excerpt.panel.title.loading": "Indlæser ...",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "Unavngivet blog-indlæg",
  "editor.fabric.share.invite.to.edit.empty.page.title": "Unavngivet side",
  "editor.fabric.share.invite.to.edit.form.title": "Invitér til at redigere",
  "editor.files.may.be.uploading": "Visse filer er måske stadig ved at blive uploadet. Vent et øjeblik og forsøg derefter igen. Hvis det ikke virker, skal du forsøge at genopfriske siden, og gen-uploade alle de filer, der virker til at være ødelagt inden offentliggørelsen.",
  "editor.generic.refresh": "Noget gik galt med editoren. Kopier dine ikke-gemte ændringer og genindlæs siden for at fortsætte med at redigere.",
  "editor.go.back": "Gå tilbage",
  "editor.heartbeat.unauthorised.warning.generic.body": "Dette indhold er blevet flyttet, begrænset eller slettet. Vi anbefaler, at du kopierer alt, hvad du har brug for og lukker editoren.",
  "editor.heartbeat.unauthorised.warning.generic.title": "Ingen adgang til denne side",
  "editor.heartbeat.unauthorised.warning.page-move.body": "Du kan ikke udgive på grund af en flyttet side eller ændring af begrænsninger. Vi anbefaler, at du kopierer alt, hvad du har brug for og lukker editoren.",
  "editor.heartbeat.unauthorised.warning.page-move.title": "Sidetilladelser har ændret sig",
  "editor.help.how.to.use.blueprint": "Sådan bruges {blueprintType}",
  "editor.help.templates": "Brug sideskabeloner",
  "editor.help.updates": "Redigerer opdateringer",
  "editor.help.updates.1.description": "Den første fase af redigeringsforbedringer er landet i blogindlæg. Responsivt indhold, bedre billedhåndtering og en mere strømlinet grænseflade. Opret et nyt blogindlæg for at tjekke det ud.",
  "editor.help.updates.1.title": "Blogindlæg",
  "editor.help.updates.2.description": "Den nye redigeringsoplevelse er nu rullet ud til mødenotater. Seneste opdateringer omfatter avanceret tabelfunktionalitet, som kan skiftes ved at klikke på en tabel, og forbedringer af hastighed og pålidelighed.",
  "editor.help.updates.2.title": "Mødenotater",
  "editor.hints.close": "Luk tips",
  "editor.hints.next": "Næste tip",
  "editor.labels": "{0}",
  "editor.labels.desc": "Rediger sideetiketter",
  "editor.labels.plural": "{0} etiketter",
  "editor.labels.singular": "{0} etiket",
  "editor.labels.zero": "Etiketter",
  "editor.learn.more": "Få mere at vide",
  "editor.location.desc": "Tilføj placering",
  "editor.minor.edit": "Giv følgere besked",
  "editor.offline.before.save.error": "Kunne ikke kommunikere med serveren Det er ikke muligt at gemme i øjeblikket",
  "editor.offline.preview.error": "Kan ikke nå serveren. Kontroller at du er forbundet til internettet og at Confluence er oppe og køre.",
  "editor.offline.save.error": "Kan ikke kommunikere med server. Det er ikke muligt at gemme på nuværende tidspunkt.",
  "editor.offline.save.error.generic": "Der var en fejl ved behandlingen af anmodningen.",
  "editor.offline.save.noauthorized": "Din session er udløbet. Du skal logge ind igen eller skifte til en anden konto for at fortsætte med at arbejde. \n <div><a href=\"/login?application=confluence\">Log ind, eller skift til en anden konto.</a></div>",
  "editor.offline.save.noauthorized.title": "Kan ikke få forbindelse til serveren",
  "editor.offline.save.page.exist.content": "En side med titlen '{'0'}' findes allerede i dette område. Indtast en anden titel til din side.",
  "editor.onboarding.draft.placeholder": "Skriv / for at få vist en liste over nyttige elementer, du kan føje til siden, f.eks. en indholdsfortegnelse eller en køreplan.<br/>Eller hvis du er helt tom for idéer, kan du starte med en af skabelonerne til højre →",
  "editor.onboarding.spotlight.body": "Find ud af hvad der bliver ændret og hvorfor.",
  "editor.onboarding.spotlight.finish": "Jeg er med",
  "editor.onboarding.spotlight.title": "Vi opdaterer dine skabeloner en ad gangen",
  "editor.onboarding.step1.content": "Vi arbejder på at levere de funktioner du har bedt om, begyndende med forbedret læsbarhed, mere intelligente formateringsværktøjer samt et mere moderne udseende.<br /><a href=''{linkCAC}' target='_blank'>Få mere at vide om hvad der bliver ændret</a>",
  "editor.onboarding.step1.title": "Venligere blogindlæg",
  "editor.onboarding.step2.content": "Dine mest brugte funktioner er i værktøjslinjen, mens mere avancerede værktøjer er under plus-tegnet. Du har også en masse nye humørikoner til at forskønne din dag! <br/><a href=''{linkCAC}' target='_blank'>Få mere at vide om hvad der bliver ændret</a>",
  "editor.onboarding.step2.title": "Leder du efter noget?",
  "editor.onboarding.step3.content": "Dette er en arbejdsproces, og vi har brug for din hjælp til at gøre den fantastisk. Send os din tilbagemelding og følg <a href=''{linkCAC}' target='_blank'>Confluence-siden</a> for at holde dig opdateret om ændringer. <br/><a href=''{linkCAC}' target='_blank'>Få mere at vide om hvad der bliver ændret</a>",
  "editor.onboarding.step3.title": "Lad os skabe noget godt sammen",
  "editor.page.can.not.be.accessed.message": "Din session kan være udløbet. Du skal logge ind igen eller skifte til en anden konto for at fortsætte med at arbejde. \n <div><a href=\"/login?application=confluence\">Log ind, eller skift til en anden konto.</a></div>",
  "editor.page.can.not.be.accessed.title": "Dette indhold kan ikke tilgås.",
  "editor.page.conflict.message": "Genindlæs siden for at prøve at genetablere forbindelsen.",
  "editor.page.conflict.title": "Kan ikke synkronisere med serveren.",
  "editor.page.is.too.big": "Denne side er for stor til at gemme. Du kan opdele den i flere sider, og så bruge <a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">inkludér side-makroen</a> for at vise indholdet.",
  "editor.page.is.trashed.message": "Kopier dit indhold og tilføj det på en ny side eller <div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">gendan denne side fra papirkurven</a> og prøv igen.</div>",
  "editor.page.is.trashed.title": "Dette indhold er blevet slettet",
  "editor.page.legacy.draft.deprecated": "Samarbejdsredigering er kommet! Det betyder, at vi har brug for lidt hjælp fra dig for at genstarte din redigeringssession. Alt du skal gøre er at kopiere indholdet, redigere denne side igen, indsætte det og gemme.",
  "editor.page.moved.message.body": "Det er okay, men du kan stadig udgive dine ændringer, når du er klar. <br /><br /> Ny placering: {0}",
  "editor.page.moved.message.title": "{0} flyttede denne side",
  "editor.page.moved.message.unknown.mover": "En anden bruger",
  "editor.placeholder.broken.image": "Korrupt billede",
  "editor.placeholder.broken.link": "Ødelagt link",
  "editor.placeholder.broken.macro": "Ødelagt makro",
  "editor.placeholder.error": "Fejl",
  "editor.preview.error": "Der opstod en fejl under indlæsning af forhåndsvisning. Prøv venligst igen senere.",
  "editor.publish.blog": "Udgiv",
  "editor.publish.blog.desc": "Udgiv dit blogindlæg",
  "editor.publish.external.share.label": "Delt eksternt",
  "editor.publish.hotkey.description": "Du skal vælge {keyCombination} på tastaturet for at offentliggøre dette indhold.",
  "editor.publish.with.comment": "Udgiv med versionskommentar...",
  "editor.publish.without.notify": "Udgiv uden at give observatører besked",
  "editor.quit-dialog.button.delete.blog.exit": "Slet blogindlæg",
  "editor.quit-dialog.button.delete.page.exit": "Slet side",
  "editor.quit-dialog.button.discard.changes.by.many": "Kasser <strong>alles </strong> ændringer",
  "editor.quit-dialog.button.discard.changes.by.one": "Kasser <strong>alle</strong> ændringer",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "Kassér alle ikke-udgivede ændringer",
  "editor.quit-dialog.button.discard.limited.tooltip": "Samarbejdsredigering er deaktiveret. Du kan kassere ændringer, når den er aktiveret igen.",
  "editor.quit-dialog.button.revert.blog.exit": "Vend tilbage til sidste version af blodindlægget",
  "editor.quit-dialog.button.revert.page.exit": "Gendan side",
  "editor.quit-dialog.button.save.exit": "Behold udkast",
  "editor.quit-dialog.cancel.changes.by.many": "<p>Der er ændringer som du og andre personer har foretaget, som endnu ikke er offentliggjorte.</p>\n<p>Hvis du kasserer ændringerne, sletter du ændringerne foretaget af følgende personer, og gendanner den senest offentliggjorte version af denne side. De vil ikke kunne gendanne deres arbejde hvis du gør dette.</p>\n\n<p>Disse personer har foretaget ændringer:</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p>Du har foretaget ændringer som endnu ikke er offentliggjorte.</p><p>Hvis du kasserer ændringer, vil dine ændringer, som ikke er offentliggjorte blive slettet. Du kan ikke fortryde denne handling.</p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "Dette vil permanent slette dette blogindlæg, som du og disse andre personer har arbejdet på.",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "Når du sletter et ikke-udgivet blogindlæg, er det væk for evigt.",
  "editor.quit-dialog.delete.page.changes.by.many": "Dette vil permanent slette denne side, som du og disse andre personer har arbejdet på.",
  "editor.quit-dialog.delete.page.changes.by.one": "Hvis du sletter en ikke-udgivet side, er den væk for evigt.",
  "editor.quit-dialog.last.edited": "Sidst redigeret",
  "editor.quit-dialog.link.hide.diff": "Skjul ændringer",
  "editor.quit-dialog.link.show.diff": "Vis ændringer",
  "editor.quit-dialog.publish.changes": "<p>Der er ændringer foretaget af dig og andre personer, der endnu ikke er blevet udgivet.</p><p>Disse personer har foretaget ændringer:</p>",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "Dette vil permanent slette alle de ændringer, du har lavet siden dette blogindlæg sidst blev udgivet",
  "editor.quit-dialog.revert.changes.by.many": "Dette vil permanent slette alle de ændringer, som følgende personer har foretaget, siden denne side sidst blev udgivet.",
  "editor.quit-dialog.revert.page.changes.by.one": "Dette vil permanent slette alle de ændringer, du har lavet, siden siden sidst blev udgivet.",
  "editor.quit-dialog.title.blogpost.delete": "Slet ikke-udgivet blogindlæg?",
  "editor.quit-dialog.title.discard": "Gendan til den sidst udgivede version?",
  "editor.quit-dialog.title.exit": "Luk editoren",
  "editor.quit-dialog.title.page.delete": "Slet ikke-udgivet side?",
  "editor.quit-dialog.title.publish": "Udgiv siden?",
  "editor.restrictions.desc": "Rediger sidebegrænsninger",
  "editor.return.to.edit": "Tilbage til redigeringstilstand",
  "editor.satisfaction.survey.description": "Hvordan var din redigeringsoplevelse?",
  "editor.satisfaction.survey.final.description": "Din tilbagemelding er blevet indsendt",
  "editor.satisfaction.survey.final.title": "Tak",
  "editor.satisfaction.survey.question.bad": "Det er vi kede af at høre. Hvad gik galt? (valgfri)",
  "editor.satisfaction.survey.question.good": "Tak! Hvad kunne du lide? Hvad ville du gøre bedre? (valgfri)",
  "editor.satisfaction.survey.title": "Din side er blevet offentliggjort",
  "editor.save.draft.desc": "Gem dit udkast",
  "editor.save.page.desc": "Gem din side",
  "editor.shared.draft.done.desc": "Gem udkastet; Kassér det, hvis det er tomt",
  "editor.shared.draft.publish.desc": "Udgiv ændringer",
  "editor.shared.draft.update.desc": "Opdater udgivet side",
  "editor.shortcuts": "Redigerer tastaturgenveje",
  "editor.synchrony.publish-page.message": "{0} udgav denne side.",
  "editor.template.changing.variable.dialog.title": "Redigér skabelonvariabel",
  "editor.template.variable.input.creation.error.action": "Besøg Atlassian Support",
  "editor.template.variable.input.creation.error.description": "Opdatér siden, og prøv igen. Hvis problemet fortsætter, skal du give os besked via linket nedenfor.",
  "editor.template.variable.input.creation.error.title": "Noget gik galt",
  "editor.template.variable.list.field.placeholder": "mulighed1, mulighed2, mulighed 3",
  "editor.template.variable.name.field": "Navn på variabel",
  "editor.title.is.empty": "Tilføj sidetitel før du trykker Udgiv.",
  "editor.title.is.empty.title": "Denne side har brug for et navn",
  "editor.title.placeholder": "Sidetitel",
  "editor.title.too.long": "Titlen må ikke være længere en 255 tegn.",
  "editor.unavailable.generic.body": "Det er ikke muligt at redigere i øjeblikket. Prøv igen om et par minutter.",
  "editor.unavailable.title": "Kan ikke redigere",
  "editor.unpublished.changes.lozenge.label": "Ikke-udgivet",
  "editor.unpublished.changes.lozenge.tooltip": "Denne side indeholder ikke-udgivede ændringer",
  "editor.waiting.to.publish.changes": "Der kan stadig være en filoverførsel i gang.",
  "editor.waiting.to.publish.changes.title": "Hav tålmodighed. Det tager et øjeblik.",
  "email.text.added.by": "Tilføjet af",
  "error.connection.lost.body": "Vi venter her, mens du genopretter forbindelse.",
  "error.connection.lost.title": "Det ser ud til, at du har mistet forbindelsen.",
  "error.connection.recovered.action": "Genindlæs indholdet",
  "error.connection.recovered.title": "Forbundet igen",
  "error.notfound.title": "Ah øv, den side kan vi ikke finde.",
  "error.recovery.body": "Dine ændringer er sikre. Opdater siden, og prøv igen.",
  "error.recovery.title": "Der gik noget galt med indlæsningen af redigeringsprogrammet",
  "error.server-error.body": "Prøv venligst igen senere.",
  "error.server-error.title": "Noget er gået galt.",
  "error.session.expired.body": "Vi holder bedre fast næste gang; det lover vi.",
  "error.session.expired.title": "Det ser ud til, at vi har mistet din session.",
  "excel.file": "Microsoft Excel-regneark",
  "excel.macro.file": "Microsoft Excel-regneark med makroer aktiveret",
  "excel.template.file": "Microsoft Excel-skabelon",
  "excel97.file": "Microsoft Excel-regneark",
  "excel97.template.file": "Microsoft Excel 97-skabelon",
  "existing.blogpost.placeholder": "Titel på blogindlæg",
  "expand-macro.default-title": "Klik her for at udvide...",
  "expand.name": "Åbn",
  "fabric.editor.announcement.datednotice.main": "På {0} vil du blive opgraderet til vores nye redigeringsoplevelse.",
  "fabric.editor.announcement.dismiss": "Afvis",
  "fabric.editor.announcement.greeting": "Hej, {0}.",
  "fabric.editor.announcement.initialnotice.main": "Om få uger vil den måde, hvorpå du opretter indhold på Confluence, blive ændret.",
  "fabric.editor.announcement.link.action": "Find ud af, hvad der er ændret, og hvilke nye funktioner du vil modtage.",
  "fabric.editor.announcement.rollbacknotice.action": "Læs meddelelsen om, hvordan du ruller eksisterende sider tilbage til de tidligere versioner.",
  "fabric.editor.announcement.rollbacknotice.main": "For nyligt blev dine sider ved et uheld opdateret til den nye redigeringsoplevelse. Det ruller vi tilbage nu.",
  "fabric.editor.announcement.tryit.action": "Prøv det på en ny side.",
  "fabric.editor.announcement.tryitnotice.main": "Den nye redigeringsoplevelse gør dine sider flottere og giver nye funktioner som live-makroer.",
  "fabric.editor.changeboarding.banner.action": "Se de nye funktioner, du kan bruge.",
  "fabric.editor.changeboarding.banner.dismiss": "Afvis",
  "fabric.editor.changeboarding.banner.main": "Hej {0}, vi laver nogle ændringer for at hjælpe dig med at skabe flottere indhold, der er lettere at læse.",
  "fabric.editor.page.removed.description": "Opdater nu.",
  "fabric.editor.page.removed.title": "Denne side blev arkiveret eller slettet for nylig",
  "fabric.editor.permission.removed.description": "Tilladelserne til denne side blev ændret. Kontakt en administrator for at få hjælp.",
  "fabric.editor.permission.removed.title": "Vi kan ikke vise denne side",
  "fabric.full.width.help.center.dialog.title": "New! Width control",
  "fabric.full.width.help.center.pageElement.details": "<p>Expands <strong>all page elements</strong> horizontally, which results in less white space. The toggle also returns the page content to fixed-width.</p>",
  "fabric.full.width.help.center.pageElement.title": "Full-width page toggle",
  "fabric.full.width.help.center.tableElement.details": "<p>Control the width of <strong>each column, table,</strong> and most <strong>macros</strong> using wide or full-width options; you can also target certain elements to remain at fixed-width.</p>",
  "fabric.full.width.help.center.tableElement.title": "Individual element toggle",
  "fabric.help.center.columns.details": "<p>Føj en <strong>kolonne</strong> til din side, og brug herefter den <strong>svævende menu</strong> til at skifte mellem konfigurationer med to eller tre kolonner.</p>",
  "fabric.help.center.columns.title": "Kolonner",
  "fabric.help.center.dialog.title": "Lær det grundlæggende",
  "fabric.help.center.imageDisplay.details": "<p>Vælg et billede, og træk herefter i dets <strong>håndtag</strong> for at ændre størrelsen. Du kan også bruge den <strong>svævende menu</strong> til at ændre dets position.</p>",
  "fabric.help.center.imageDisplay.title": "Billedvisning",
  "fabric.help.center.layouts.details": "<p>Brug <kbd>←</kbd> <kbd>→</kbd> til at ændre, hvordan kolonner, tabeller og makroer vises.</p><p>Vælg mellem <strong>fastlåst bredde</strong>, der holdes bredden ens mellem skærme, <strong>fuld bredde</strong>, der udvider bredden og fylder skærmen, eller en mellemting med indstillingen <strong>bred</strong>.</p>",
  "fabric.help.center.layouts.title": "Layouts",
  "fabric.help.center.menuitem.title": "Vejledning",
  "fabric.help.center.slashCommands.details": "<p>Tryk på <kbd>/</kbd> for at åbne en menu og indsætte indhold som <strong>tabeller</strong>, <strong>makroer</strong> og <strong>datoer</strong>på din side, når du ønsker det.</p>",
  "fabric.help.center.slashCommands.title": "Skråstregskommandoer",
  "fabric.help.center.spotlight.body": "Kom tilbage når som helst for at følge vejledningen.",
  "fabric.help.center.spotlight.header": "Har du brug for at få noget genopfrisket?",
  "fabric.help.center.tableManipulation.details": "<p>Redigér, eller formatér tabeller fra rullemenuen <strong>tabelkanter</strong> <strong></strong>og den <strong>svævende menu</strong>.</p>",
  "fabric.help.center.tableManipulation.title": "Ændring af tabel",
  "fabric.help.center.templates.details": "<p>Find en skabelon, der opfylder dine behov. Åbn panelet igen fra menuen Flere handlinger (•••), når det er lukket.</p>",
  "fabric.help.center.templates.title": "Skabeloner",
  "fabric.help.center.title": "Lær det grundlæggende",
  "fabric.insert.external.image": "Indsæt billede fra web",
  "fabric.template.can.not.parse.content": "Vi kan ikke åbne skabelonen, fordi den indeholder elementer, der er i stykker eller ikke understøttes.",
  "fabric.template.can.not.save.error.title": "Kan ikke gemme ændringer",
  "fabric.template.can.not.save.error.title.duplicate": " Der findes allerede en skabelon ved navn <strong>{0}</strong>. Giv din skabelon en anden titel for at gemme den.",
  "fabric.template.found.invalid.node": "Flere skabelonvariabler, som har samme navn \"{variableNames}\", men forskellige parametre.",
  "favourite.spaces": "Mine rum",
  "feedback.flag.thanks.description": "Din feedback hjælper os med at bygge en bedre oplevelse.",
  "feedback.flag.thanks.title": "Tak!",
  "filter.name": "Filter",
  "gif.file": "GIF-fil",
  "global.spaces": "Siderum",
  "globaladminbilling.label": "Fakturering",
  "header.or.footer.unsupported.macros.list": "De følgende makroer understøttes i øjeblikket ikke i {0}:",
  "header.or.footer.unsupported.macros.title": "Ikke understøttede makroer",
  "heading.comment": "Ændret af",
  "heading.createpage": "Opret side",
  "heading.createpage.sentence": "Opret side",
  "heading.operations": "Operationer",
  "heading.version.date": "Udgivet",
  "heading.version.number": "Version",
  "help.name": "Hjælp",
  "help.us.improve": "Hjælp os med at blive bedre",
  "hipchat.presence.status.available": "Tilgængelig",
  "hipchat.presence.status.away": "Ikke til stede",
  "hipchat.presence.status.dnd": "Forstyr ikke",
  "hipchat.presence.status.offline": "Offline",
  "html.file": "HTML-fil",
  "icon.tooltip.remove": "Fjern",
  "icon.tooltip.undo": "Fortryd",
  "image.browser.imageurl.label": "Billed-URL",
  "image.height": "Højde",
  "image.properties.dialog.cancel": "Annuller",
  "image.properties.dialog.heading": "Billedegenskaber",
  "image.properties.trigger": "Egenskaber",
  "image.properties.trigger.tooltip": "Indstil yderligere billedegenskaber",
  "inline.comment.sidebar.navigate.next.description": "Næste Inline-kommentar",
  "inline.comment.sidebar.navigate.previous.description": "Forrige Inline-kommentar",
  "inline.comments.GROW-1507.dialog.close.label": "Luk",
  "inline.comments.GROW-1507.dialog.content": "Kender du til inline-kommentarer?<br>Du kan bruge den til at gennemgang ved at tilføje dem til en bestemt del af dokumentet.",
  "inline.comments.GROW-1507.dialog.header": "Inline-kommentarer",
  "inline.comments.GROW-1507.dialog.ok.label": "Ok, vi forstår",
  "inline.comments.GROW-1507.dialog.showme.label": "Vis mig",
  "inline.comments.GROW-1507.dialog.title": "KOMMENTAR-TIP",
  "inline.comments.batch.email.view": "Se kommentar",
  "inline.comments.create.placeholder": "skriv en kommentar…",
  "inline.comments.create.reply.placeholder": "Svar",
  "inline.comments.date.friendly.about.one.hour.ago": "1 time siden",
  "inline.comments.date.friendly.about.x.days.ago": "{0} dage siden",
  "inline.comments.date.friendly.about.x.hours.ago": "{0} timer siden",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "lige nu",
  "inline.comments.date.friendly.one.min.ago": "1 minut siden",
  "inline.comments.date.friendly.x.mins.ago": "{0, plural, one {for {0} minut siden} other {for {0} minutter siden}}",
  "inline.comments.date.friendly.yesterday": "i går",
  "inline.comments.delete.confirmation.message": "Er du sikker på, du vil slette denne kommentar?",
  "inline.comments.delete.permission": "Du har ikke tilladelse til at slette denne kommentar.",
  "inline.comments.delete.reply.confirmation.message": "Er du sikker på, du vil slette dette svar?",
  "inline.comments.delete.with.reply": "Du kan ikke slette inline-kommentartråde med svar",
  "inline.comments.delete.with.reply.need.reload": "Du kan ikke slette denne kommentar, fordi der er nye svar i tråden. Genindæse for at se dem.",
  "inline.comments.edit.permission": "Du har ikke tilladelse til at redigere denne kommentar.",
  "inline.comments.editor.lost": "Din kommentar vil gå tabt.",
  "inline.comments.editor.timeout": "Redigeringsprogrammet blev ikke indlæst korrekt. {0}Genindlæs siden{1} for at prøve igen.",
  "inline.comments.expand.replies": "{0} flere svar",
  "inline.comments.fabric.editor.error.cannot.be.empty": "Din kommentar er tom. Tilføj din feedback, og klik på Gem.",
  "inline.comments.fabric.editor.error.captcha.check.failed": "Captcha-tjek mislykkedes",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "Captcha-tjek udført",
  "inline.comments.fabric.editor.error.create.not.permitted": "Med dine aktuelle tilladelsesindstillinger har du ikke adgang til at oprette kommentarer. Spørg din administrator, om du har brug for adgang til dette.",
  "inline.comments.fabric.editor.error.delete.not.permitted": "Med dine aktuelle tilladelsesindstillinger har du ikke adgang til at slette kommentarer. Spørg din administrator, om du har brug for adgang til dette.",
  "inline.comments.fabric.editor.error.edit.not.permitted": "Med dine aktuelle tilladelsesindstillinger har du ikke adgang til at redigere kommentarer. Spørg din administrator, om du har brug for adgang til dette.",
  "inline.comments.fabric.editor.error.invalid.selection": "Kunne ikke oprette kommentar. Lav din fremhævning på mere unik tekst for at gøre valget tydeligt, så din kommentar knyttes til det rette indhold.",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "Med dine aktuelle tilladelsesindstillinger har du ikke adgang til at løse kommentarer. Spørg din administrator, om du har brug for adgang til dette.",
  "inline.comments.fabric.editor.error.unexpected": "Der gik noget galt under forsøget på at gemme denne kommentar. Luk kommentaren, eller genindlæs siden, og prøv at tilføje din kommentar igen.",
  "inline.comments.fabric.editor.error.view.not.permitted": "Med dine aktuelle tilladelsesindstillinger har du ikke adgang til at se kommentaren. Spørg din administrator, om du har brug for adgang til dette.",
  "inline.comments.fabric.inline.button.cancel": "Annuller",
  "inline.comments.fabric.inline.button.save": "Gem",
  "inline.comments.fabric.sidebar.loading.error": "Der opstod en fejl. Luk kommentarvinduet, og prøv igen.",
  "inline.comments.likes.error": "Likes kan ikke opdateres.",
  "inline.comments.likes.like": "Like",
  "inline.comments.likes.unlike": "Unlike",
  "inline.comments.navigation.index.of": "{0} af {1}",
  "inline.comments.notification.email.reopened": "Genåbnet",
  "inline.comments.notification.email.resolved": "Løst",
  "inline.comments.notification.email.view": "Se kommentar",
  "inline.comments.resolve.permission": "Du har ikke tilladelse til at løse denne kommentar.",
  "inline.comments.resolved.dangling.message": "Løst fordi teksten blev slettet af {0} {1}",
  "inline.comments.resolved.dialog.empty": "Der er ingen løste kommentarer på denne side.",
  "inline.comments.resolved.dialog.message": "Denne kommentar er ikke forsvundet for evigt! Du kan til enhver tid se løste kommentarer.",
  "inline.comments.resolved.dialog.show.me": "Vis mig",
  "inline.comments.resolved.discovery.button.dismiss": "Ok, vi forstår",
  "inline.comments.resolved.discovery.content": "Har du mere du vil sige? Du kan genåbne løste kommentarer for at fortsætte diskussionen.",
  "inline.comments.resolved.menu.show.replies": "{0} svar",
  "inline.comments.resolved.menu.show.reply": "{0} svar",
  "inline.comments.resolved.menu.unresolve": "Genåbn",
  "inline.comments.resolved.message": "Løst af {0} {1}",
  "inline.comments.resolved.view.menu": "Løste kommentarer",
  "inline.comments.server.edit.error": "Vi kan ikke gemme din redigering. Kommentaren er muligvis blevet slettet.",
  "inline.comments.server.error": "Kunne ikke fuldføre din anmodning.",
  "inline.comments.server.error.edit.comment": "Vi kan ikke redigere denne kommentar. Kommentaren er muligvis blevet slettet.",
  "inline.comments.server.error.edit.reply": "Vi kan ikke redigere dette svar. Svaret er muligvis blevet slettet.",
  "inline.comments.sidebar.cancel": "Annullér",
  "inline.comments.sidebar.close": "Luk",
  "inline.comments.sidebar.comment.empty": "Du kan ikke gemme en som kommentar.",
  "inline.comments.sidebar.delete": "Slet",
  "inline.comments.sidebar.deleted": "Slettet",
  "inline.comments.sidebar.discard": "Kassér",
  "inline.comments.sidebar.edit": "Rediger",
  "inline.comments.sidebar.error.create.comment": "Vi kan ikke tilføje din inline-kommentar. Sektionen du fremhævede indeholder en makro eller brugerbemærkning. Forsøg at fremhæve almindelig tekst.",
  "inline.comments.sidebar.error.delete.generic": "Fejl ved sletning af kommentar. Kontrollér Confluence-logfilerne for fejl.",
  "inline.comments.sidebar.error.delete.unauthorised": "Du har ikke tilstrækkelige tilladelser til at slette denne kommentar.",
  "inline.comments.sidebar.error.empty": "Indtast din kommentar.",
  "inline.comments.sidebar.error.save.comment": "Kunne ikke gemme kommentaren",
  "inline.comments.sidebar.error.save.reply": "Kunne ikke gemme svaret",
  "inline.comments.sidebar.error.stale": "Sideindhold udløbet, {0}opdater{1} og prøv igen.",
  "inline.comments.sidebar.like": "Like",
  "inline.comments.sidebar.pagecomment.success": "Sidekommentar er oprettet korrekt",
  "inline.comments.sidebar.reply": "Svar",
  "inline.comments.sidebar.resolve": "Løs",
  "inline.comments.sidebar.resolved": "Løst",
  "inline.comments.sidebar.save": "Gem",
  "inline.comments.sidebar.saved": "Gemt",
  "inline.comments.sidebar.shortcuts.close.description": "Luk Inline-kommentar",
  "inline.comments.sidebar.show.resolved.comment": "Vis løste kommentarer",
  "inline.comments.sidebar.tooltip.close.description": "Luk sidebjælke (])",
  "inline.comments.sidebar.tooltip.next.ic.description": "Næste kommentar (N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "Forrige kommentar (P)",
  "inline.comments.templates.create.a.comment": "<strong>kommenterede</strong> på en side",
  "inline.comments.templates.resolved.a.comment": "<strong>løste</strong> en kommentar",
  "inline.comments.templates.resolved.a.comment.dangling": "slettet tekst refereret til af en inline-kommentar, så kommentaren blev <strong>løst</strong>",
  "inline.comments.templates.unresolved.a.comment": "<strong>genåbende</strong> en kommentar",
  "inline.comments.unresolved.message": "Genåbnet af {0} {1}",
  "jar.file": "Java-arkiv",
  "java.file": "Java-kilde",
  "jpeg.file": "JPEG-fil",
  "js.file": "JavaScript-fil",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl",
  "keyboard.shortcut.option": "Option",
  "keyboard.shortcut.shift": "Skift",
  "label.contains.invalid.chars": "<b>{0}</b> indeholder ugyldige tegn ({1}).",
  "label.name.is.too.long": "Etiketnavne skal indeholde færre end {0} tegn.",
  "labels.dialog.shortcut.tip": "Genvejstip: I sidevisning, ved at trykke på <b>{shortcut}</b> åbnes denne dialogboks også",
  "labels.none": "Ingen etiketter",
  "labels.title": "Etiketter",
  "last.saved": "Sidst gemt",
  "likes.bethefirst": "Vær den første til at synes godt om dette",
  "likes.follow": "Følg",
  "likes.following": "Følger",
  "likes.like": "Synes godt om",
  "likes.peoplewholikethis": "Personer der synes godt om dette",
  "likes.summary.1.non-promoted": "{0} synes godt om dette",
  "likes.summary.1.promoted": "{0} synes godt om dette",
  "likes.summary.1.promoted.1.non-promoted": "{0} og {1} synes godt om dette",
  "likes.summary.2.promoted": "{0} og {1} synes godt om dette",
  "likes.summary.2.promoted.1.non-promoted": "{0}, {1} og {2} synes godt om dette",
  "likes.summary.3.promoted": "{0}, {1} og {2} synes godt om dette",
  "likes.summary.3.promoted.1.non-promoted": "{0}, {1}, {2} og {3} synes godt om dette",
  "likes.summary.you": "Du synes godt om dette",
  "likes.summary.you.1.non-promoted": "Du og {0} synes godt om dette",
  "likes.summary.you.1.promoted": "Du og {0} synes godt om dette",
  "likes.summary.you.1.promoted.1.non-promoted": "Du, {0} og {1} synes godt om dette",
  "likes.summary.you.2.promoted": "Du, {0} og {1} synes godt om dette",
  "likes.summary.you.2.promoted.1.non-promoted": "Du, {0}, {1} og {2} synes godt om dette",
  "likes.summary.you.3.promoted": "Du, {0}, {1} og {2} synes godt om dette",
  "likes.summary.you.3.promoted.1.non-promoted": "Du, {0}, {1}, {2} og {3} synes godt om dette",
  "likes.unlike": "Synes ikke længere godt om",
  "limited.mode.existing.editor.body": "Samarbejdsredigering er offline lige nu, og {0} redigerer denne side. Prøv igen om et par minutter.",
  "link.browser.advanced.desc1": "For at indsætte et link på en ny side skal du indtaste den ønskede sidetitel.",
  "link.browser.advanced.desc2": "Skriv #anchorname for at indsætte et ankerlink",
  "link.browser.advanced.error.internal.error": "Der opstod en intern serverfejl",
  "link.browser.advanced.error.not.link": "Den angivne markup er ikke en gyldig linkmarkup",
  "link.browser.advanced.error.unknown.shortcut": "{0} er ikke en genkendt genvej",
  "link.browser.advanced.error.unknown.space": "{0} er ikke et genkendt rum",
  "link.browser.advanced.title": "Her kan du indsætte et link til siden med <a href=\"{0}\" target=\"_blank\">wiki markup</a>.",
  "link.browser.autocomplete.hint": "Tip: skriv \"[\" i editoren for at se en liste over foreslåede sider og indsæt et link.",
  "link.browser.cancel.button": "Annuller",
  "link.browser.edit.button": "Indsæt",
  "link.browser.edit.title": "Rediger link",
  "link.browser.file.attach": "Upload fil",
  "link.browser.file.attach.desc": "Link til en fil, der er knyttet til denne side eller vedhæft en ny.",
  "link.browser.file.attach.upload.in.progress": "Upload i gang...",
  "link.browser.file.browse.button": "Gennemse",
  "link.browser.files.none": "Der er ingen filer på denne side.",
  "link.browser.insert.button": "Indsæt",
  "link.browser.insert.title": "Indsæt link",
  "link.browser.link": "Link",
  "link.browser.link.alias": "Linktekst",
  "link.browser.link.image.label": "Forbind billede",
  "link.browser.location": "Linkplacering",
  "link.browser.recently.viewed.load.error": "Der opstod en fejl under indlæsning af de nyligt sete sider",
  "link.browser.recently.viewed.none": "Du har ikke noget nyligt vist indhold.",
  "link.browser.search": "Søg",
  "link.browser.search.for": "Søg efter",
  "link.browser.search.invalid": "Ugyldige søgeord",
  "link.browser.search.results.load.error": "Der opstod en fejl under søgningen",
  "link.browser.search.results.none": "Ingen søgeresultater blev fundet.",
  "link.browser.space.all": "Al indhold",
  "link.browser.tab.name.advanced": "Avanceret",
  "link.browser.tab.name.files": "Filer",
  "link.browser.tab.name.recently.viewed": "Nyligt sete",
  "link.browser.tab.name.search": "Søg",
  "link.browser.tab.name.weblinks": "Weblink",
  "link.browser.table.file.comment": "Kommentar",
  "link.browser.table.file.name": "Navn",
  "link.browser.table.file.size": "Størrelse",
  "link.browser.table.last.modified": "Sidst ændret",
  "link.browser.table.space": "Rum",
  "link.browser.table.title": "Titel",
  "link.browser.web.link": "URL",
  "link.browser.web.link.desc": "Web-, e-mail- eller en anden internetadresse",
  "link.browser.web.link.label": "Adresse",
  "location.name": "Placering",
  "login.button": "Log ind",
  "look.and.feel": "Udseende og følelse",
  "marketplace.link.name": "Marketplace-apps",
  "more.word.action": "Flere handlinger",
  "more.word.capitalised": "Mere",
  "moveblogpost.already.exists.in.target.space": "Et andet blogindlæg med samme titel og dato eksisterer allerede i det valgte rum.",
  "moveblogpost.source.notfound": "Kildeblogindlægget blev ikke fundet.",
  "moveblogpost.target.space.notfound": "Målområdet blev ikke fundet.",
  "moveblogpost.target.space.same.as.origin": "Du kan ikke flytte et blogindlæg til det rum, det allerede er i.",
  "multimedia.file": "Multimediefil",
  "my.drafts.mainBanner": "Indfang idéer hurtigt",
  "my.drafts.subBanner": "Opret en side, og notér dine idéer. Hvis ikke du er klar til udgivelse endnu, skal du bare lukke siden. Vi gemmer den automatisk som en kladde, så du kan vende tilbage til den, når du er klar. ",
  "my.spaces.tooltip.add": "Tilføj til Mine rum",
  "my.spaces.tooltip.remove": "Fjern fra Mine rum",
  "name.word": "Navn",
  "nav.controller.activity": "Aktivitet",
  "nav.controller.activity.feed": "Aktivitets-feed",
  "nav.controller.all.spaces": "Rum",
  "nav.controller.discover": "Opdag",
  "nav.controller.my.spaces": "Mine rum",
  "nav.controller.my.spaces.anchor": "Alle",
  "nav.controller.my.spaces.blank": "Hav dine mest nyttige rum lige ved hånden. Tryk på stjerneikonet ud for ethvert rum for at få det til at stå her.",
  "nav.controller.my.spaces.blank.callToAction": "Find rum",
  "nav.controller.projects": "Projekter",
  "nav.controller.recent": "Recent pages",
  "nav.controller.your.work": "Dit arbejde",
  "navigation.app.switcher.apps": "Programmer",
  "navigation.app.switcher.dont.show.again": "Vis ikke igen",
  "navigation.app.switcher.edit": "Rediger",
  "navigation.app.switcher.error-message": "Fejl ved indhentning af programlinks.",
  "navigation.app.switcher.home.description": "Hjem",
  "navigation.app.switcher.img.alt": "Applikationsskifter",
  "navigation.app.switcher.loading": "Indlæser...",
  "navigation.app.switcher.recent": "Nylige",
  "navigation.app.switcher.recent-containers-confluence-space": "Rum",
  "navigation.app.switcher.recent-containers-jira-project": "Projekt",
  "navigation.app.switcher.try.other.apps": "Prøv andre programmer",
  "navigation.app.switcher.use.confluence": "Brug Confluence",
  "navigation.app.switcher.use.jira": "Brug Jira",
  "navigation.label-for-bell": "Notifikationer",
  "navigation.label-for-global-people-icon": "Mappe med personer",
  "navigation.notification-drawer-title": "Start notifikationer",
  "navigation.people-drawer-title": "Mappe med personer",
  "navlink.edit": "{0}R{1}ediger",
  "network.page": "Netværksside",
  "no.drafts.found": "Ingen udkast fundet",
  "no.matches.mainBanner": "Vi kan ikke finde noget for",
  "no.name": "Nej",
  "no.permission": "Ingen tilladelse",
  "no.spaces.found": "Ingen rum blev fundet.",
  "not.watching.anything": "Du følger ikke noget.",
  "notification.start": "Start med at følge",
  "notification.stop": "Stop med at følge",
  "notifications.batch.inline.comment.created.section.header": "{0, choice, 1#Indbygget kommentar|1<Indbyggede kommentarer}",
  "notifications.batch.inline.comment.new.lozenge": "ny",
  "notifications.batch.inline.comment.reopened.lozenge": "genåbnede",
  "notifications.batch.inline.comment.resolved": "$user $lozenge en kommentar",
  "notifications.batch.inline.comment.resolved.lozenge": "løste",
  "notifications.preferences.desc": "Du kan angive dine indstillinger om påmindelse for e-mails på siden <a href=\"viewmyemailsettings.action\">e-mailindstillinger</a>.",
  "onboarding-choose-a-space.description": "Vælg blandt et af dit teams nuværende rum. Du kan oprette flere rum senere.",
  "onboarding-choose-a-space.title": "Vælg et rum at arbejde i",
  "onboarding.choose-a-space.backBtn": "Tilbage",
  "onboarding.choose-a-space.nextBtn": "Næste",
  "onboarding.choose-a-space.selectLabel": "Rumnavn",
  "onboarding.choose-a-space.selectPlaceholder": "Vælg områdets navn",
  "onboarding.create-a-space.backBtn": "Tilbage",
  "onboarding.create-a-space.description": "Start med et rum til dit nuværende projekt eller team. Du kan oprette flere rum senere.",
  "onboarding.create-a-space.inputTextLabel": "Navn",
  "onboarding.create-a-space.inputTextPlaceholder": "Krystaller",
  "onboarding.create-a-space.invalidMessage": "Pladsnavne kræver mindst et bogstav eller tal.",
  "onboarding.create-a-space.nextBtn": "Næste",
  "onboarding.create-a-space.title": "Opret et rum at arbejde i",
  "onboarding.dialog.existing-user.cancel": "Vis ikke tips",
  "onboarding.dialog.existing-user.confirm": "Så kører vi",
  "onboarding.dialog.existing-user.content": "Vi har flyttet et par ting rundt for at give dig en bedre oplevelse på betjeningspanelet og aktiveret nogle tips for at hjælpe dig med at komme i gang.",
  "onboarding.dialog.existing-user.title": "Velkommen til dit nye betjeningspanel!",
  "onboarding.dialog.new-user.cancel": "Vis ikke tips",
  "onboarding.dialog.new-user.confirm": "Så kører vi",
  "onboarding.dialog.new-user.content": "Betjeningspanelet er destinationssiden, der hjælper dig med at navigere rundt i Confluence. <br/>Vi har aktiveret nogle tips for at hjælpe dig på vej",
  "onboarding.dialog.new-user.title": "Velkommen til betjeningspanelet!",
  "onboarding.navigation.blog.tip.blog.list.byline": "Tryk på Hjem for at skifte til en liste over sider eller andet indhold.",
  "onboarding.navigation.blog.tip.blog.list.heading": "Din blogliste kan stadig blive fundet her",
  "onboarding.navigation.dont.show": "Vis mig ikke flere tips",
  "onboarding.navigation.global.sidebar.byline": "Så uanset hvor du er i Confluence, er de vigtige ting kun et klik væk.",
  "onboarding.navigation.global.sidebar.heading": "Dette sidepanel er nu universelt",
  "onboarding.navigation.ok": "OK, det er forstået",
  "onboarding.navigation.page.tip.page.tree.byline": "Tryk på hjem for at skifte til en liste over blogs eller andet indhold.",
  "onboarding.navigation.page.tip.page.tree.heading": "Dit sidetræ kan stadig findes her",
  "onboarding.navigation.space.tip.space.tabs.byline": "Startsiden til dit rum er nu oversigten, og dine sider, blogindlæg og andet indhold har hver deres fane.",
  "onboarding.navigation.space.tip.space.tabs.heading": "Dit indhold er nu organiseret i faner",
  "onboarding.tooltip.actions.done": "Det er forstået!",
  "onboarding.tooltip.actions.next": "Næste",
  "onboarding.tooltip.actions.skip": "Spring tips over",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "Gå direkte til dine favoritområde, eller besøg listen over alle rum.",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "Favoritrum ved dine fingerspidser",
  "onboarding.tooltip.existing-user.sidebar.content": "Find nye sider og vend tilbage til dit nylige arbejde fra dit nye stilrene sidepanel.",
  "onboarding.tooltip.existing-user.sidebar.title": "Opdag mere med sidepanelet",
  "onboarding.tooltip.new-user.favourite-spaces.content": "Gå direkte til dine favoritrum eller besøg listen over alle rum.",
  "onboarding.tooltip.new-user.favourite-spaces.title": "Favoritrum ved dine fingerspidser",
  "onboarding.tooltip.new-user.sidebar.content": "Find nye sider og vend tilbage til dit seneste arbejde fra sidepanelet.",
  "onboarding.tooltip.new-user.sidebar.title": "Opdag mere med sidepanelet",
  "onboarding.tooltip.saved-for-later.content": "Dine favoritsider kan nu ses under det nye navn - Gemt til senere.",
  "onboarding.tooltip.saved-for-later.title": "Farvel favoritter, sig hej til Gemt til senere",
  "onboarding.who-is-on-your-team.addMoreBtn": "+ tilføj flere e-mails",
  "onboarding.who-is-on-your-team.description": "Confluence er bedre, når teammedlemmer opretter, diskuterer og samarbejder med dig om arbejdet.",
  "onboarding.who-is-on-your-team.emailPlaceholder": "Tilføj e-mailadresse",
  "onboarding.who-is-on-your-team.enableDRS": "Du kan lade alle med en bekræftet {domain}-e-mailadresse tilmelde sig din side (vi giver dig besked, hver gang det sker).",
  "onboarding.who-is-on-your-team.enableOpenInvite": "Lad brugere invitere andre til din side.",
  "onboarding.who-is-on-your-team.form.invalid.email": "Indtast en gyldig e-mail",
  "onboarding.who-is-on-your-team.nextBtn": "Næste",
  "onboarding.who-is-on-your-team.title": "Hvem er i dit team?",
  "only.personal.labels.permitted": "Du må kun tilføje personlige etiketter på denne side.",
  "org.randombits.confluence.toc.toc.label": "Indholdsfortegnelse",
  "page.already.exists": "En anden side med samme titel eksisterer allerede i det valgte rum.",
  "page.already.exists.inspace": "Siden '{'0'}' findes allerede i området '{'1'}'. Du skal omdøbe sidetitlen, før du flytter den.",
  "page.change": "Hvad har du ændret?",
  "page.comments.saved.dialog.message": "Din kommentar er blevet gemt som en kommentarside.",
  "page.comments.sidebar.warning": "Vi kan ikke tilføje en inline-kommentar til dette indhold. Vi vil tilføje en sidekommentar i stedet for.",
  "page.descendent.already.exists": "En nyere side deler samme titel med en anden side i det valgte rum.",
  "page.permissions.menu.item.title": "Begrænsninger",
  "page.permissions.menu.item.title.tooltip": "Rediger begrænsninger",
  "page.tree.blankExperience.mainBanner": "Der er ikke andet her end potentiale.",
  "page.tree.blankExperience.subBanner": "Opret nogle mødenotater, produktkrav, how-to-artikler eller andet indhold for at se området blive fyldt ud.",
  "page.watch.instruction": "For at følge en side eller et blogindlæg: åben ‘Værktøjer’-menuen og klik på ‘Følg’.",
  "page.watches": "Sidevisninger",
  "page.word": "Side",
  "pages.navigation.discovery.body.html": "Klik <strong>Sider</strong> for at vise sidetræet og gennemse sider i dette rum.",
  "pages.navigation.discovery.header": "Sidetræet bor her nu",
  "pages.show.all": "Vis alle sider",
  "pages.word": "Sider",
  "pagetree.dragndrop.failed.action.visitsupport": "Besøg Atlassian Support",
  "pagetree.dragndrop.failed.description": "Genindlæs siden, og prøv igen. Giv os besked via linket nedenfor, hvis problemet fortsætter.",
  "pagetree.dragndrop.failed.title": "Noget gik galt.",
  "pagetree.failed.load.content": "Sidetræet kunne ikke indlæses",
  "pagetree.failed.load.tooltip": "Et øjeblik, vi arbejder på en løsning.",
  "parent.page.invalid.for.space": "Der er ingen side med titlen <b>{0}</b> i området <b>{1}</b>.",
  "parent.page.name": "Overordnet side",
  "pdf.file": "PDF-fil",
  "people.directory.name": "Personer",
  "period.lastSevenDays": "I sidste uge",
  "period.lastThirtyDays": "I den sidste måned",
  "period.older": "Mere end en måned siden",
  "period.today": "I dag",
  "period.yesterday": "I går",
  "permission.owner.not.in.group": "Du kan kun give sidetilladelser til grupper, du er medlem af",
  "permission.owner.not.set": "Du skal vælge en ejer for tilladelsen",
  "permissions.comment": "Definer hvem der kan se og redigere siden. Du kan begrænse disse tilladelser til dig selv eller en gruppe af brugere.",
  "permissions.edit.title": "Rediger",
  "permissions.select.nopermissions": "Ikke indstillet",
  "permissions.view.title": "Vis",
  "person.follow": "Følg",
  "person.follow.stop": "Stop med at følge",
  "personal.spaces": "Personlige rum",
  "placeholder.placeholdertext.label": "Pladsholdertekst",
  "placeholder.replacementtext.label": "Udskiftningstekst",
  "please.enter.a.label": "Skriv venligst en etiket.",
  "png.file": "PNG-fil",
  "popular.stream.mainBanner": "Der sker ikke så meget... Endnu",
  "popular.stream.subBanner": "Det er ret roligt lige nu, men når dit hold begynder at arbejde, vises de mest populære sider og filer her.",
  "popular.stream.subBanner2": "Lad os få gang i festen!",
  "popular.stream.title": "Populær",
  "posted.word": "Lagt ud",
  "powerpoint.file": "Microsoft Powerpoint-præsentation",
  "powerpoint.macro.file": "Microsoft Powerpoint-præsentation med makroer aktiveret",
  "powerpoint.slideshow.file": "Microsoft Powerpoint-slideshow",
  "powerpoint.template.file": "Microsoft Powerpoint-skabelon",
  "powerpoint97.file": "Microsoft Powerpoint 97-slideshow",
  "powerpoint97.template.file": "Microsoft Powerpoint 97-skabelon",
  "product.name": "Confluence",
  "profile.page": "Profilside",
  "property.panel.macro.display.inline": "Vis inline",
  "property.panel.macro.display.newline": "Vis på ny linje",
  "property.panel.macro.edit": "Rediger",
  "property.panel.macro.remove": "Fjern",
  "property.panel.textplaceholder.display.default": "Tekst",
  "property.panel.textplaceholder.display.default.tooltip": "Instruktionsteksten erstattes med tomt indhold, når en person skriver.",
  "property.panel.textplaceholder.display.mention": "Brugeromtale",
  "property.panel.textplaceholder.display.mention.tooltip": "Instruktionsteksten erstattes med anbefalede personer, når en person skriver.",
  "property.panel.textplaceholder.remove": "Fjern",
  "property.panel.variable.display.list": "Liste",
  "property.panel.variable.display.list.tooltip": "Rulleliste",
  "property.panel.variable.display.string": "Tekst",
  "property.panel.variable.display.string.tooltip": "Indtastningsfelt med enkelt tekstlinje",
  "property.panel.variable.display.textarea": "Tekst med flere linjer",
  "property.panel.variable.display.textarea.tooltip": "Indtastningsfelt med flere tekstlinjer",
  "property.panel.variable.list.values.tooltip": "Indtast hvert element til listen, adskil dem med et komma.",
  "property.panel.variable.textarea.columns.tooltip": "Antal kolonner der skal vises for feltet.",
  "property.panel.variable.textarea.rows.tooltip": "Antal rækker der skal vises for feltet.",
  "quick.comment.placeholder.message": "Skriv en kommentar...",
  "quick.reload.edit": "Nye sideredigeringer",
  "quick.reload.edit.by": "af",
  "quick.reload.edit.more": "og {0} andre",
  "quick.reload.edit.one.more": "og 1 anden",
  "quick.reload.edits": "{0} nye redigeringer",
  "quick.reload.newcomments": "{0} nye kommentarer",
  "quick.reload.newpagecomment": "Ny kommentar",
  "quick.reload.reload": "Genindlæs side",
  "recently-updated-content-list.commented.new": "Kommenteret {time}",
  "recently-updated-content-list.created.new": "Oprettet {time}",
  "recently-updated-content-list.edited.new": "Opdateret {time}",
  "recently.viewed.mainBanner": "Tid til at spille en historisk rolle",
  "recently.viewed.subBanner": "Du har endnu ikke besøgt nogen sider, men når du gør, lægger vi dem her, så du hurtigt kan vende tilbage til dem.",
  "recently.viewed.subBanner2": "Gå over til et <b>rum</b> nu og tag dig et kig rundt.",
  "recently.viewed.title": "Nyligt besøgte",
  "recently.worked.mainBanner": "Færdiggør mesterværket",
  "recently.worked.subBanner": "Du har ikke lavet eller redigeret noget endnu, men når du gør det, lægger vi det her, så det er let at fortsætte, fra hvor du slap.",
  "recently.worked.subBanner2": "Nu kan du gå i gang med at lave dit bedste arbejde.",
  "recently.worked.title": "Nyligt arbejdede på",
  "remove.comment.confirmation.message": "Er du sikker på, at du vil slette kommentaren?",
  "remove.label": "Slet etiket",
  "resize.image.dialog.title": "Tilpas størrelse på billedet",
  "restore.this.version": "Gendan",
  "result.grid.column.content.last.modified": "Sidst ændret",
  "resume.editing": "Genoptag",
  "return.to.page.info": "Gå tilbage til sideoplysninger",
  "satisfaction.survey.reaction.amazing": "Fantastisk",
  "satisfaction.survey.reaction.bad": "Dårligt",
  "satisfaction.survey.reaction.great": "Godt",
  "satisfaction.survey.reaction.okay": "Okay",
  "satisfaction.survey.reaction.terrible": "Forfærdeligt",
  "save.name": "Gem",
  "scheme.desc.custom": "Et tilpasset farveskema, som kan redigeres.",
  "scheme.desc.global": "Dette farveskema bruger et globalt defineret farveskema til dette rum.",
  "scheme.title.custom": "Tilpasset farveskema",
  "scheme.title.global": "Globalt farveskema",
  "search.drawer.recently.viewed": "Nyligt sete",
  "search.drawer.recently.viewed.spaces": "Seneste rum",
  "search.name": "Søg",
  "settings.name": "Indstillinger",
  "share.button.restriction.message.text": "Begrænsninger på denne side kan forhindre personer i at se eller redigere",
  "share.button.text": "Del",
  "show.more.blogposts": "Vis flere blogindlæg",
  "sidebar.avatar.picker.upload.error": "Der opstod en fejl under opdatering af rumoplysninger",
  "sidebar.main.back.to.overview": "Tilbage til oversigt",
  "sidebar.main.back.to.space": "Gå tilbage til rum",
  "sidebar.main.blog": "Blog",
  "sidebar.main.quick.links": "Genveje til rum",
  "sidebar.main.settings": "Rum indstillinger",
  "sidebar.main.shortcuts": "Links",
  "sidebar.main.wiki": "Sider",
  "site-settings.templates-and-blueprints.edit-button-label": "Rediger",
  "space.404.banner.title": "Ups, du har fundet et dødt link",
  "space.404.go.back": "Gå tilbage til",
  "space.404.go.to": "Gå til",
  "space.404.home.page": "siden \"Hjem\"",
  "space.404.previous.page": "forrige side",
  "space.create": "Opret rum",
  "space.home.blog.blankExperience.mainBanner": "Har du noget at dele?",
  "space.home.blog.blankExperience.subBanner": "Blogindlæg er en fantastisk måde at dele meddelelser, statusrapporter eller andre vigtige nyheder med dit hold.",
  "space.home.overview.blankExperience.mainBanner": "Nå så, det her er en smule akavet.",
  "space.home.overview.blankExperience.subBanner": "Dette rum har ikke en hjemside, så der er ikke noget at vise her. Trist panda.",
  "space.home.overview.blankExperience.subBanner2": "Tilføj en hjemmeside nu for at gøre det hele lækkert, og brug den til at fortælle dine besøgende, hvad dette rum handler om!",
  "space.not.exists": "Det rum, du har angivet, findes ikke.",
  "space.personal.name": "Personligt rum",
  "space.set.space.home": "Indstil områdets startside",
  "space.watch.instruction": "Klik på 'Sider' eller 'Blog' i områdets sidepanel for at følge sider eller blogindlæg i området.",
  "space.watches": "Fulgte rum",
  "spaces.all": "Alle rum",
  "spaces.lookandfeel.help": "Her kan du tilpasse udseendet for dette Confluence-rum.",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">Bemærk:</span> <i>Enhver ændring, der laves her, vil overskrive standard-farveskemaet og standard-dekoratørerne, som er indstillet af din administrator.</i>",
  "spaces.word": "Rum",
  "starred.mainBanner": "Intet at se her... Endnu",
  "starred.spaces.tooltip.add": "Stjernemarkér dette område",
  "starred.spaces.tooltip.remove": "Fjern stjernemarkering fra dette område",
  "starred.subBanner": "Tryk på <b>stjerneikonet</b> for at gemme en side til senere. Vi lægger det her, så du kan finde det, når du får brug for det.",
  "starred.title": "Gemt til senere",
  "status.lozenge.draft": "Udkast",
  "status.lozenge.unpublished": "Ikke-udgivede ændringer",
  "submit.name": "Indsend",
  "super-admin.banner.exit": "Stop brug af administratornøglen",
  "super-admin.banner.message": "Du bruger administratornøglen, hvilket giver dig midlertidig adgang til begrænset indhold.",
  "switch.apps": "Skift apps",
  "system.help.legal": "Det juridiske",
  "team.create.flag.error.description": "Vi var ikke i stand til at oprette et hold til dig. Prøv snart igen.",
  "team.create.flag.error.title": "Ups! Noget gik galt.",
  "team.created.flag.description": "{membersCount, plural, one {Du har inviteret {membersCount} person til teamet '{'teamName'}'} other {Du har inviteret {membersCount} personer til teamet '{'teamName'}'}}",
  "team.created.flag.title": "Nyt team oprettet",
  "team.created.flag.view": "Vis team",
  "template.variables.fabric.section.message": "Denne skabelon bruger variable. Når du indtaster dem, bliver de oplysninger, du angiver, inkluderet i indholdet på din nye side.",
  "templates.name": "Skabeloner",
  "text.file": "Tekstfil",
  "text.selected": "Valgte",
  "tinymce.advanced.block": "Format",
  "tinymce.advanced.blockquote": "Citat",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "Fed",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "Punktliste",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Skift+B",
  "tinymce.advanced.charmap_desc": "Symbol",
  "tinymce.advanced.forecolor_desc": "Vælg tekstfarven",
  "tinymce.advanced.formatting_desc": "Formatering",
  "tinymce.advanced.h1": "Overskrift 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "Overskrift 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "Overskrift 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "Overskrift 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "Overskrift 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "Overskrift 6",
  "tinymce.advanced.h6_shortcut": "Ctrl+6",
  "tinymce.advanced.headings": "Overskrifterne 1 til 6",
  "tinymce.advanced.headings_shortcut": "Ctrl+1..6",
  "tinymce.advanced.hr_desc": "Horisontal regel",
  "tinymce.advanced.indent_desc": "Ryk ind",
  "tinymce.advanced.italic_desc": "Kursiv",
  "tinymce.advanced.italic_shortcut": "Ctrl+I",
  "tinymce.advanced.justifycenter_desc": "Juster i midten",
  "tinymce.advanced.justifyfull_desc": "Fuld justering",
  "tinymce.advanced.justifyleft_desc": "Juster til venstre",
  "tinymce.advanced.justifyright_desc": "Juster til højre",
  "tinymce.advanced.numlist_desc": "Nummereret liste",
  "tinymce.advanced.numlist_shortcut": "Ctrl+Skift+N",
  "tinymce.advanced.outdent_desc": "Ryk ud",
  "tinymce.advanced.paragraph": "Paragraf",
  "tinymce.advanced.paragraph_shortcut": "Ctrl+0",
  "tinymce.advanced.pre": "Præformatteret",
  "tinymce.advanced.pre_shortcut": "Ctrl+7",
  "tinymce.advanced.redo_desc": "Gentag",
  "tinymce.advanced.redo_shortcut": "Ctrl+Y",
  "tinymce.advanced.striketrough_desc": "Streg igennem",
  "tinymce.advanced.striketrough_shortcut": "Ctrl+Skift+S",
  "tinymce.advanced.sub_desc": "Sænket skrift",
  "tinymce.advanced.sup_desc": "Hævet skrift",
  "tinymce.advanced.tasklist_desc": "Opgaveliste",
  "tinymce.advanced.tasklist_shortcut": "[ derefter ]",
  "tinymce.advanced.underline_desc": "Understreg",
  "tinymce.advanced.underline_shortcut": "Ctrl+U",
  "tinymce.advanced.undo_desc": "Fortryd",
  "tinymce.advanced.undo_shortcut": "Ctrl+Z",
  "tinymce.advanced.unlink_desc": "Fjern tilknytning",
  "tinymce.atlassian.help": "Hjælp",
  "tinymce.atlassian.insert_menu": "Indsæt",
  "tinymce.atlassian.insert_menu.charmap_desc": "Indsæt symbol",
  "tinymce.atlassian.insert_menu.content_desc": "Indsæt indhold",
  "tinymce.atlassian.insert_menu.hr_desc": "Indsæt horisontal regel (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "Indsæt makro",
  "tinymce.atlassian.insert_menu.tooltip": "Indsæt mere indhold",
  "tinymce.atlassian.monospace": "Monospatieret",
  "tinymce.atlassian.monospace_desc": "Formater tekst med monospatieret skrift",
  "tinymce.atlassian.more_menu": "Mere",
  "tinymce.atlassian.remove_formatting": "Ryd formatering",
  "tinymce.atlassian.remove_formatting_desc": "Rydder formatering på den valgte tekst",
  "tinymce.auiwindowmanager.cancel": "Annuller",
  "tinymce.auiwindowmanager.ok": "OK",
  "tinymce.autocomplete.web.resource.name": "Webressourcer til Confluence automatisk udfyldelse",
  "tinymce.autocomplete.web.resource.only.name": "Webressourcer til Confluence automatisk udfyldelse uden afhængigheder",
  "tinymce.charmap.web.resource.name": "Webressourcer til TinyMce-tegnkort",
  "tinymce.charmap_dlg.title": "Indsæt symbol",
  "tinymce.colorpicker.color": "Farve",
  "tinymce.colorpicker.more_colors": "Flere farver",
  "tinymce.colorpicker.picker_tab": "Vælger",
  "tinymce.colorpicker.picker_title": "Farvevælger",
  "tinymce.colorpicker.title": "Vælg en farve",
  "tinymce.colorpicker.web.resource.name": "Confluence farvevælger webressourcer",
  "tinymce.confluence.conf_emoji": "Emoji",
  "tinymce.confluence.conf_emoticon": "Humørikon",
  "tinymce.confluence.conf_emoticon_desc": "Indsæt humørikon",
  "tinymce.confluence.conf_file": "Filer og billeder",
  "tinymce.confluence.conf_file_desc": "Indsæt filer og billeder",
  "tinymce.confluence.conf_file_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_image": "Billede",
  "tinymce.confluence.conf_image_desc": "Indsæt billede",
  "tinymce.confluence.conf_image_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_link": "Link",
  "tinymce.confluence.conf_link_desc": "Indsæt link",
  "tinymce.confluence.conf_link_shortcut": "Ctrl+K",
  "tinymce.confluence.conf_macro_browser": "Makro",
  "tinymce.confluence.conf_macro_browser_desc": "Indsæt makro",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl+Skift+A",
  "tinymce.confluence.conf_media": "Billede/Medie",
  "tinymce.confluence.conf_other_macros_desc": "Andre makroer...",
  "tinymce.confluence.conf_shortcuts_help": "Hjælp til genvejstaster",
  "tinymce.confluence.conf_tasklist": "Opgaveliste",
  "tinymce.confluence.conf_tasklist_desc": "Indsæt opgaveliste",
  "tinymce.confluence.conf_tasklist_shortcut": "[ derefter ]",
  "tinymce.confluence.conf_widget_desc": "Widget",
  "tinymce.confluence.conf_wikimarkup": "Markup",
  "tinymce.confluence.conf_wikimarkup.insert.label": "Indsæt",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "Confluence wiki",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "Wiki markup konverteringsfejl",
  "tinymce.confluence.conf_wikimarkup_desc": "Indsæt markup",
  "tinymce.confluence.conf_wikimarkup_hint": "Tip: Du kan også indtaste wiki markup direkte i editoren, hvor den bliver formateret, når du skriver.",
  "tinymce.confluence.conf_wikimarkup_info_title": " Indtast wiki markup eller markdown nedenfor. Confluence konverterer dit indhold til editor-formatet og indsætter det på din side.",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "Markdown",
  "tinymce.confluence.conf_wikimarkup_preview_label": "Forhåndsvisning",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl+Skift+D",
  "tinymce.confluence.conf_wikimarkup_timeout": "Serveren tog for lang tid om at konvertere wiki markup'en Det kan være, at dette kun er et midlertidigt problem, så du kan prøve igen.",
  "tinymce.confluence.files": "Filer",
  "tinymce.confluence.help_desc": "Hjælp",
  "tinymce.confluence.htmlsource": "Kilde",
  "tinymce.confluence.htmlsource_desc": "Se HTML-kilde",
  "tinymce.confluence.layout.menu": "Sidelayout",
  "tinymce.confluence.layout.none": "Ingen layout",
  "tinymce.confluence.layout.three_col": "Tre kolonner",
  "tinymce.confluence.layout.three_col_sidebars": "Tre kolonner (venstre og højre sidepanel)",
  "tinymce.confluence.layout.three_col_simple": "Tre kolonner (enkel)",
  "tinymce.confluence.layout.two_col": "To kolonner",
  "tinymce.confluence.layout.two_col_left": "To kolonner (venstre sidepanel)",
  "tinymce.confluence.layout.two_col_right": "To kolonner (højre sidepanel)",
  "tinymce.confluence.layout.two_col_simple": "To kolonner (enkel)",
  "tinymce.confluence.layout.two_col_simple_left": "To kolonner (enkel, venstre sidepanel)",
  "tinymce.confluence.layout.two_col_simple_right": "To kolonner (enkel, højre sidepanel)",
  "tinymce.confluence.macro_insert": "Indsæt makroen '{'0'}'",
  "tinymce.confluence.macro_other": "Andre makroer",
  "tinymce.confluence.macro_other_desc": "Åben makrobrowseren",
  "tinymce.confluence.placeholder.inline.tasks": "Indtast din opgave her ved hjælp af \"@\" for at tildele en bruger og \"//\" for at vælge en frist",
  "tinymce.confluence.preview": "Forhåndsvisning",
  "tinymce.confluence.preview_shortcut": "Ctrl+Skift+E",
  "tinymce.confluence.save_shortcut": "Ctrl+S",
  "tinymce.confluence.settings_desc": "Editor-indstillinger",
  "tinymce.confluence_dlg.insertbutton.title": "Indsæt",
  "tinymce.confluence_dlg.insertimage.title": "Indsæt billede",
  "tinymce.confluence_dlg.insertlink.title": "Indsæt link",
  "tinymce.emotions.emotions_desc": "Humørikoner",
  "tinymce.emotions.web.resource.name": "Webressourcer til TinyMce-humørikoner",
  "tinymce.emotions_dlg.add": "Plus (+)",
  "tinymce.emotions_dlg.biggrin": "Stort grin :D",
  "tinymce.emotions_dlg.broken_heart": "Knust hjerte </3",
  "tinymce.emotions_dlg.check": "Tick (/)",
  "tinymce.emotions_dlg.desc": "Humørikoner",
  "tinymce.emotions_dlg.error": "Fejl (x)",
  "tinymce.emotions_dlg.forbidden": "Minus (-)",
  "tinymce.emotions_dlg.heart": "Hjerte <3",
  "tinymce.emotions_dlg.help_16": "Spørgsmålstegn (?)",
  "tinymce.emotions_dlg.information": "Info (i)",
  "tinymce.emotions_dlg.lightbulb": "Lyspære fra (fra)",
  "tinymce.emotions_dlg.lightbulb_on": "Lyspære tændt (tændt)",
  "tinymce.emotions_dlg.sad": "Trist :(",
  "tinymce.emotions_dlg.smile": "Smil :)",
  "tinymce.emotions_dlg.star_blue": "Blå stjerne (*b)",
  "tinymce.emotions_dlg.star_green": "Grøn stjerne (*g)",
  "tinymce.emotions_dlg.star_red": "Rød stjerne (*r)",
  "tinymce.emotions_dlg.star_yellow": "Gul stjerne (*y)",
  "tinymce.emotions_dlg.thumbs_down": "Tommelfinger ned (n)",
  "tinymce.emotions_dlg.thumbs_up": "Tommelfinger op (y)",
  "tinymce.emotions_dlg.title": "Indsæt humørikon",
  "tinymce.emotions_dlg.tongue": "Rækker tunge :p",
  "tinymce.emotions_dlg.warning": "Advarsel (!)",
  "tinymce.emotions_dlg.wink": "Blink ;)",
  "tinymce.fabric.migration.dialog.action": "Fortsæt med at redigere",
  "tinymce.fabric.migration.dialog.content": "Ingen grund til bekymring, dine ændringer er ikke tabt. Vi blev bare nødt til at opdatere siden.",
  "tinymce.fabric.migration.dialog.title": "Vi har lige opdateret din redigeringsoplevelse",
  "tinymce.formatting.paragraph": "Normal tekst",
  "tinymce.full_screen.toolbar_item": "Fuld skærm",
  "tinymce.full_screen.toolbar_item_title": "Start editoren i fuldskærm",
  "tinymce.hints.autoformat.code": "Tip: Skriv \"<strong>'{{'code'}}'</strong>\" for hurtigt at indsætte tekst med fast mellemrum.",
  "tinymce.hints.autoformat.heading1": "Tip: Skriv \"<strong>h1. Titel </strong>\" for hurtigt at indsætte en Overskrift 1.",
  "tinymce.hints.autoformat.heading3": "Tip: Skriv \"<strong>h3. Titel </strong>\" for hurtigt at indsætte en Overskrift 3.",
  "tinymce.hints.dnd": "Tip: du kan trække og slippe billeder og Office-filer fra din computer direkte ind i denne editor.",
  "tinymce.hints.drafts": "Tip: Confluence gemmer automatisk udkast. Hvis du nogensinde lukker et vindue, kan du gendanne dit arbejde fra menuen \"Brugernavn -> Udkast\".",
  "tinymce.hints.insert.bullet.list": "Tip: tryk på <strong>Ctrl+Skift+B</strong> for at lave en punktopstilling.",
  "tinymce.hints.insert.heading": "Tip: tryk på <strong>Ctrl+1</strong> for at oprette en overskrift, <strong>Ctrl+2</strong> for en underoverskrift og så videre.",
  "tinymce.hints.insert.image": "Tip: tryk på <strong>Ctrl+M</strong> for at åbne billedbrowseren.",
  "tinymce.hints.insert.image.end": "Tip: tryk på <strong>Ctrl+Skift+M</strong> efter et ord for at finde og indsætte relevante billeder.",
  "tinymce.hints.insert.image.on.page": "Tip: skriv \"<strong>!</strong>\" for at se billeder vedhæftet siden og indsætte et af dem.",
  "tinymce.hints.insert.image.search": "Tip: skriv \"<strong>!</strong>\" og en del af et billednavn for at finde og indsætte billedet.",
  "tinymce.hints.insert.link": "Tip: tryk <strong>Ctrl+K</strong> for at åbne linkbrowseren.",
  "tinymce.hints.insert.link.end": "Tip: tryk på <strong>Ctrl+Skift+K</strong> efter et ord for at finde og linke til relevante sider. Tryk på den igen for flere forslag.",
  "tinymce.hints.insert.link.newpage": "Tip: skriv \"<strong>[</strong>\" og titlen på en ny side, du ønsker at oprette, for at se et forslag til et indsat link.",
  "tinymce.hints.insert.link.recently.viewed": "Tip: skriv \"<strong>[</strong>\" for at se en liste over anbefalede sider og indsæt et link.",
  "tinymce.hints.insert.link.search": "Tip: skriv \"<strong>[</strong>\" og en del af en sidetitel for at finde og linke til den side.",
  "tinymce.hints.insert.link.user.mention": "Tip: Du kan nævne nogen i Confluence ved at skrive \"<strong>@</strong>\" og derefter deres navn.",
  "tinymce.hints.insert.macro": "Tip: tryk på <strong>Ctrl+Skift+A</strong> for at åbne makrovinduet.",
  "tinymce.hints.insert.macro.toc": "Tip: Lad Confluence generere en indholdsfortegnelse for denne side for dig. Brug \"Indsæt -> Indholdsfortegnelse\"",
  "tinymce.hints.insert.newline": "Tip: Tryk <strong>Skift+Enter</strong> for at indsætte et nyt afsnit uden mellemrum",
  "tinymce.hints.insert.numbered.list": "Tip: tryk på <strong>Ctrl+Skift+N</strong> for at lave en nummereret liste.",
  "tinymce.hints.insert.table": "Tip: tryk på <strong>Ctrl+Skift+I</strong> for at indsætte en tabel.",
  "tinymce.hints.insert.wikimarkup": "Tip: Editoren konverterer automatisk wiki markup, når du skriver den",
  "tinymce.hints.insert.wikimarkup.dialog": "Tip: tryk på <strong>Ctrl+Skift+D</strong> for at åbne Wiki Markup-vinduet.",
  "tinymce.hints.table.rows.copy": "Tip: tryk på <strong>Ctrl+Skift+C</strong> for at kopiere en række og <strong>Ctrl+Skift+V</strong> for at indsætte en række i en tabel.",
  "tinymce.hints.table.rows.cut": "Tip: tryk på <strong>Ctrl+Skift+X</strong> for at klippe en række og på <strong>Ctrl+Skift+V</strong> for at indsætte en række i en tabel.",
  "tinymce.macro.preview.exception": "Der opstod en fejl, mens man makroen blev forhåndsvist. Fejl: {0}",
  "tinymce.macro.unknownMacro": "Makroen '{'0'}' er ukendt. Den kan være blevet fjernet fra systemet.",
  "tinymce.popup_blocked": "Browseren har blokeret en popup åbnet af editoren.",
  "tinymce.propertypanel.images.border": "Kant",
  "tinymce.propertypanel.images.border.tooltip": "Vis en kant omkring billede",
  "tinymce.propertypanel.images.large": "Stor",
  "tinymce.propertypanel.images.large.tooltip": "Gør billedets størrelse stor og link til originalen",
  "tinymce.propertypanel.images.link.create": "Link",
  "tinymce.propertypanel.images.link.create.tooltip": "Forbind dette billede til andet indhold",
  "tinymce.propertypanel.images.link.edit": "Rediger link",
  "tinymce.propertypanel.images.link.edit.tooltip": "Rediger linket til dette billede",
  "tinymce.propertypanel.images.link.remove": "Fjern tilknytning",
  "tinymce.propertypanel.images.link.remove.tooltip": "Fjern linket for dette billede",
  "tinymce.propertypanel.images.medium": "Medium",
  "tinymce.propertypanel.images.medium.tooltip": "Gør billedets størrelse medium og link til originalen",
  "tinymce.propertypanel.images.original": "Original",
  "tinymce.propertypanel.images.original.tooltip": "Nulstil billedstørrelse til original",
  "tinymce.propertypanel.images.sizing.tooltip": "Ændr størrelsen på billedet til en bestemt bredde",
  "tinymce.propertypanel.images.small": "Lille",
  "tinymce.propertypanel.images.small.tooltip": "Gør billedets størrelse lille og link til originalen",
  "tinymce.propertypanel.links.edit": "Rediger",
  "tinymce.propertypanel.links.edit.tooltip": "Rediger link i en dialog",
  "tinymce.propertypanel.links.goto": "Gå til link",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "Dette link fører til indholdet på den side, du redigerer",
  "tinymce.propertypanel.links.unlink": "Fjern tilknytning",
  "tinymce.propertypanel.links.unlink.tooltip": "Udskift link med den tekst, det indeholder",
  "tinymce.searchreplace.replace_desc": "Find/erstat",
  "tinymce.searchreplace.search_desc": "Find",
  "tinymce.searchreplace_dlg.allreplaced.plural": "{0} ord blev erstattet",
  "tinymce.searchreplace_dlg.allreplaced.singular": "1 element blev erstattet",
  "tinymce.searchreplace_dlg.close": "Luk",
  "tinymce.searchreplace_dlg.direction": "Retning",
  "tinymce.searchreplace_dlg.down": "Ned",
  "tinymce.searchreplace_dlg.findlabel": "Find",
  "tinymce.searchreplace_dlg.findnext": "Næste",
  "tinymce.searchreplace_dlg.findprevious": "Tidligere",
  "tinymce.searchreplace_dlg.findwhat": "Find hvad",
  "tinymce.searchreplace_dlg.mcase": "Match tilfælde",
  "tinymce.searchreplace_dlg.notfound": "Intet blev erstattet",
  "tinymce.searchreplace_dlg.replace": "Erstat",
  "tinymce.searchreplace_dlg.replace_title": "Find/erstat",
  "tinymce.searchreplace_dlg.replaceall": "Erstat alt",
  "tinymce.searchreplace_dlg.replacelabel": "Erstat",
  "tinymce.searchreplace_dlg.search_title": "Find",
  "tinymce.searchreplace_dlg.searchnext_desc": "Find igen",
  "tinymce.searchreplace_dlg.up": "Op",
  "tinymce.style.show-eol-markers": "Â¶",
  "tinymce.style.show-eol-markers.title": "Vis/skjul linjemarkører ved linjestop",
  "tinymce.table": "Tabel",
  "tinymce.table.cell": "Celle",
  "tinymce.table.col": "Kolonne",
  "tinymce.table.col_after_desc": "Indsæt kolonne efter",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+Mulighed+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Shift+→",
  "tinymce.table.col_before_desc": "Indsæt kolonne før",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+Option+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Shift+←",
  "tinymce.table.col_copy_desc": "Kopier tabelkolonne",
  "tinymce.table.col_cut_desc": "Klip tabelkolonne",
  "tinymce.table.col_highlight": "Overskriftskolonne",
  "tinymce.table.col_paste_desc": "Indsæt tabelkolonne",
  "tinymce.table.copy_row_desc": "Kopier tabelrække",
  "tinymce.table.copy_row_shortcut": "Ctrl+Skift+C",
  "tinymce.table.cut_row_desc": "Klip tabelrække",
  "tinymce.table.cut_row_shortcut": "Ctrl+Skift+X",
  "tinymce.table.del": "Fjern tabel",
  "tinymce.table.delete_col_desc": "Fjern kolonne",
  "tinymce.table.delete_row_desc": "Fjern række",
  "tinymce.table.desc": "Indsæt tabel",
  "tinymce.table.fixed_width": "Fast bredde",
  "tinymce.table.fixed_width_tooltip": "Træk i kolonnekanter for at indstille bredden. Tabellen vises altid med den bredde, du har angivet.",
  "tinymce.table.highlight_colour": "Farve på fremhævning",
  "tinymce.table.merge_cells_desc": "Flet tabelceller",
  "tinymce.table.more.heading": "Tabelindstillinger",
  "tinymce.table.numbering_column_desc": "Indsæt nummereringskolonne",
  "tinymce.table.paste_row_after_desc": "Indsæt række efter",
  "tinymce.table.paste_row_before_desc": "Indsæt tabelrække",
  "tinymce.table.paste_row_before_shortcut": "Ctrl+Skift+V",
  "tinymce.table.responsive": "Responsiv",
  "tinymce.table.responsive_tooltip": "Tabelkolonner bliver bredere, som du tilføjer indhold. Træk kolonnekanter for at indstille bredde i forhold til hinanden og siden.",
  "tinymce.table.row": "Række",
  "tinymce.table.row_after_desc": "Indsæt række efter",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+Mulighed+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Shift+↓",
  "tinymce.table.row_after_shortcut": "Alt+â†“",
  "tinymce.table.row_before_desc": "Indsæt række før",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+Mulighed+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Shift+↑",
  "tinymce.table.row_before_shortcut": "Alt+↑",
  "tinymce.table.row_highlight": "Overskriftsrække",
  "tinymce.table.selection_highlight": "Skift cellefarve",
  "tinymce.table.split_cells_desc": "Opdel flettede tabelceller",
  "tinymce.table_dlg.cols": "Kolonner",
  "tinymce.table_dlg.equal.width.columns": "Lige bredde kolonner",
  "tinymce.table_dlg.fullwidth": "Fuld bredde",
  "tinymce.table_dlg.heading": "Første række er en overskrift",
  "tinymce.table_dlg.invalid_table_field": "Rækker og kolonner skal begge være tal større end nul.",
  "tinymce.table_dlg.rows": "Rækker",
  "tinymce.table_dlg.sizetofit": "Indholdets størrelse",
  "tinymce.table_dlg.title": "Indsæt tabel",
  "tinymce.table_dlg.width": "Bredde",
  "tinymce.table_shortcut": "Ctrl+Skift+I",
  "tinymce.tablepicker.insert_table": "Tabel",
  "tinymce.tablepicker.insert_table_title": "Indsæt tabel",
  "tinymce.tablepicker.nested_table_unsupported": "Indlejrede tabeller er ikke understøttet",
  "tinymce.tablepicker.pickerbox.tooltip": "Hold SKIFT nede for en tabel uden en overskrift.",
  "tinymce.templates.actions.defined": "Elementer der skal indsættes på denne side.",
  "tinymce.templates.insert-template": "Skabelon",
  "tinymce.templates.insert-template.tooltip": "Indsæt skabelonelementer på denne side.",
  "tinymce.templates.placeholder": "Instruktionstekst",
  "tinymce.templates.placeholder.add": "Pladsholder",
  "tinymce.templates.placeholder.add.tooltip": "Indsæt en pladsholdertekst på siden.",
  "tinymce.templates.placeholder.tooltip": "Forsvinder når en bruger skriver og vises ikke, når man er på en side.",
  "tinymce.templates.variables.add": "Ny variabel",
  "tinymce.templates.variables.add.tooltip": "Tilføj et nyt felt på siden som skabelonbrugeren skal udfylde.",
  "tinymce.templates.variables.defined": "Variabler der skal indsættes på denne side.",
  "tinymce.templates.variables.insert.tooltip": "Indsæt feltet '{'0'}' på siden, så skabelonbrugeren kan udfylde det.",
  "tinymce.templates.variables.manage": "Administrer variabler",
  "tinymce.templates.variables.none": "Ingen variabler defineret",
  "tinymce.templates.variables.none.tooltip": "Der er ikke oprettet nogle variabler.",
  "tinymce.tools.toolbar_item_hide": "Skjul værktøjer",
  "tinymce.tools.toolbar_item_hide_title": "Skjul værktøjslinjerne",
  "tinymce.tools.toolbar_item_show": "Vis værktøjer",
  "tinymce.tools.toolbar_item_show_title": "Vis værktøjslinjerne",
  "tinymce.web.css.resource.name": "CSS-webressourcer til Confluence-editoren",
  "tinymce.web.js.resource.name": "Javascript-webressourcer til Confluence-editoren",
  "tinymce.web.resource.name": "Webressourcer til Confluence-editoren",
  "title.add.blogpost": "Tilføj blogindlæg",
  "title.add.page": "Tilføj side",
  "title.add.page.template": "Opret skabelon",
  "title.comment": "Kommentar",
  "title.dashboard": "Betjeningspanel",
  "title.edit.page.template": "Redigér skabelon",
  "title.manage.groups": "Grupper",
  "title.name": "Titel",
  "type.allcontent": "Alt indhold",
  "unknown.file": "Fil",
  "unsaved.comment.lost": "Din kommentar vil gå tabt.",
  "unsaved.content.lost": "Ændringer du lavede vil muligvis ikke blive gemt.",
  "unsaved.template.lost": "Dine ikke-gemte skabelonændringer vil gå tabt",
  "untitled.draft.title": "Uden titel",
  "upm.marketplace.section": "Atlassian Marketplace",
  "usermanagement.label": "Brugerhåndtering",
  "usermanagement.parent.label": "Administration af websted",
  "users.name": "Brugere",
  "view-changes-dialog.close.dialog": "Luk",
  "view-changes-dialog.editor.quit-dialog.title.diff": "Ikke-udgivne ændringer",
  "view.change": "vis ændring",
  "view.profile": "Vis profil",
  "viewdrafts.page.desc": "Når du redigerer en side, men ikke udgiver ændringerne, oprettes et udkast. Tryk på <b>Fortsæt</b> for at fortsætte med at redigere eller udgive ændringerne.",
  "welcome.message.edit": "Del nyttige links, meddelelser og info her",
  "welcome.message.edit.link": "Tilpas",
  "word.file": "Microsoft Word-dokument",
  "word.template.file": "Microsoft Word-skabelon",
  "word97.file": "Microsoft Word 97-dokument",
  "word97.template.file": "Microsoft Word 97-skabelon",
  "xml.file": "XML-fil",
  "yes.name": "Ja",
  "your.profile.and.settings": "Din profil og indstillinger",
  "zip.file": "ZIP-arkiv"
}